import * as React from 'react';

// Sunglasses
var polarizedGrey = 'data:image/png;base64,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';
var polarizedOrange = 'data:image/png;base64,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';
var readingGrey = 'data:image/png;base64,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';
var readingOrange = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAKNUlEQVRoQ9Wae3DVxRXHP2d/9yYgAUGhVZCCrwJqCQpWrG8ZRqiQey82Vev4aGs7Fl/gUG3VUXSsVscKVkSr2Fq0pZ2U5BeiBXSKYFF5CYgiojy0oFKlBJBIknt/ezq7uTeGEMjlqe5feeyePd9z9uw537M/YR+HllJEhu4ovRAGqPJdoAdwGNA5K34j8D/gHRHeQlmEspoC1koZ2/ZFBdnbxVpKAWmuV7guq2wRYBA+RHlLYT00KlckcBTwPaA9YIEaYIPAH7A8IdP4bG902WMAWkJfDD9WuNwrrswX4eVImRsELJJyPt6dIjqCI6OIAYFwpipnI5wGfCjCkyiTJeT9PQGSN4CsxUcqjAPSwIsS50dSxpY92bD5XE3QXeGPCOcAcYHRb8eZeGIZ9fnIzQuAjuBUtYwHBiI8l8lwX7wNC6WMKJ9NWpujQymkLSerZQyQAOZKwHUyleWtrd0tAD2XGJ04T5W/AxkLN8ZCprQmdF/+HyW5TuB2oECEiynmXzLWx0yLY7cAMkl+auARYJnAZYSsEdB9UbC1tToWU/s6PQoDb6i+VrgyVkHZHgFwlo86cqWBicDrEqdUyviwtc335/81SU+FvwL9LVwd9OMvLXmiRQ9oisGqVAJLpSPny9PU7k/l8pWlV9FGNzML6BcJg+IVvNZ87U4AsgHrFi0XuGRPr7V8lct3npbSTdNMBXqKZahMY0nTtTsA0FLaaprZLpPWRZzetoq1+W50IOdpkmMVb/3lK+Jc0PSK3QFAlGSswG0ijKKYx3YX/QdS4Z1yBUiU5BIDkxWuDUKeyM1pBKAlHKeG94CpJuQHB1PBfPeyKSpRBomhr5Szxq37AkCScQ6dGM6WcublK/RgzqsfzsBYwMsqTAgquKkRgJbQXg1vC6ygjuEynbqDqVi+e2kpgaaZBpwgcXpJGfXeA1GKh0QZJUoPqWRdvgK/jHlayqGaplqFMUGF07uUIk2zWGCjhL7c/coPm+A1hEKJc4a48lgNrwhMlJBbvvLaA5rkfoVrRBgomQQpI0y1SiJWSVVLAHQoHSjkVKv0RuhmhE5+nqIWVhplMdtZLC94krLboUk6opyH0NvCN41Q6BZYZSuw3ghLqGe5PE/1rgRlEgw3QoUISYlS/EaUW8XQNUdGXEIjYiCWwQqDEU5CqVZlBsIGhCNEOQvYpLDIQDeFkxFWWstTgTATS0SGdsSoQYmiGJcZJYVytArzgVUGTlb4lsJ7CFtFOQ683Djwhgj/zMDsWIZXpIrPc4AcKVLLR6rcKTZJCJxvQjrkJkRJbhcYCwTZv81U2GxCLnXVqCMh1nCFjVgQM6yhH2vtEh5UZYExTHald9ZDIuKM64fjxBstjAtCnvVyUgzJWFSF6oKQBe6WIcOcyPKUEX4H3tORwsQg5IamHrEp1jtu7QC8A7xvQoY0AeAzsreCpcQahpk4T7try81JpzjdWC5UWB10Yoor9jTlGZXjvYcr3IzSrcmG72bg4gCuNHHG5IiQJvi+FfoYZYFU8m9/KpPcjGCsJRDhHv835dGg0nPvxmGTzACOdgBqFKYEIVc3umg4nTVggcDDRDyZc5+nlRnaU0y1KzPUJcIL6UgN22U2tc6CW7dyaPu2TBdhMTFusxmuQjk2q/h2r5CTU0sH+rPJy3HEqYs/AduckTxDa8Ohqp5f15qQds3jIUoySSDhAKjCw0HIqOYA1PKANayJh7zgN3ZHRxgbWSYUTGOJ28i24QZjmSGVvFmdpGMHuFfgAiv8MlZBeTrJoABuV6UsqPT8Ak3RBxdbsEIqeFFTfMMqY9OGB9uUs8aVNdbwE8HPO8eEvkWzw4iSjBe4sWUAl9NOP2OhFcaJUmgMoZSz3gOA0aYTt/pj0wDgliiiygFyADoKD6kyQiKOkyo2+kpSmKOuxopxh2sCaIpvWxhmapkk09nqgtJa7jPCvVLBuw4AASNV6S3QW0KO2R2ATxUqdzhCIJpkgSj3Y3iZLlTLE6S969sQl2carkt/hIbS+eMYNV2r+NwdIZvhcVE6m5BU7rhomqUqTDLFjPdH5ufEWYfJlSz+90/pRIzNTY5Qkaov7T8xIYN2cYQudR5YCaxtGsRucpTkEQP/Jc4j3moJurtWlpSxoaaErocYiiVkuvYnzpH0ZBvrOIzOGrFQhDulScmrSQYpXC8OVII+9QYtrGCFszxKMfXMZwPb6EbxtjQfFBWxJVPHwMAwR5VxQWVD4dZCEPd0AF5AOMFU+BukcWiSoQr3KbwThFwSlXCNFdbGK5kZJXjMbGdMLnFFCR42hrutcpW4GKijizsaO2yYYHq9MqpQOAthlYTM1gQpCphBO5QaYmS4BpgsFXwSJZjiuhIWSmOhZ2TNATj5s1pMZN71/Ylrd2aJ4UYpZ3G6hMExodZdd7XDOL4w4Aj3sztWUR1DAqFIhYcyEcmCqp3L8XSKMwOlyl2J1vC847fOqxnD8bEa5tOViM30lYZ84JihS3ZHSYZ+8hz/2cG4uUTmYkaTJF2AWSXZvJRIJ7ggEO4X4TdELPNZNZPt0QhBXYw2hRm6IPxMYagID1DBuF21XjIpRhjltwKTUOYQYxN1fI7JtmpixBHakuF0Fe6wws0ttVSypUSlKBeJu9JUmSfwePNizgdpkh5WGIIyQBq6zbkEdUjWKp8IzCLgb3yH1a3RUB1BD6v8UJThPtO6uko9sdqCskWFVbjyxFCVY10tBLAz0tViXTXaUE6/6dK8CTm1+eSv4u/ZcvpwiXNKA6FJMMa5/2tBaFwzWPhAhfGOVnoALhA1zUfAfIlTsr+atvvbey5xaiFzgSPEcoJ7U2gk9VHSB9+1mYizW7pF9rcyeyMvm09mKEwIQkY7GU3bKo6ZvQHMbJ7U9mazA7HGJvkHcJFYjpdpPti/AJCNhdEiPCjwC/oxqbUb5UAo2ZJM17G2Sxkp+FNyj4TclZvXvLXoYuEloJfAaRKy+mApubt9sgXhayhrJc65UoYvy3fygA/ohteYmcAHAqkvvbnb0DF8FjhRDOdLOQubgv3atNdFSDju0NxTLQNo/sBhuSIXNAfrSGV7tY5fuweOkcFm/iyzs1y7iRL5PzEJV1DMqgMd2C5gWcrRir9xelm4Phby1K4Ml+8jXzlQL8IdUsGjB9ILUYpfifrXSuMf+ap5qSXL7zKIW7zGGgJ7AnCKCK+i3E0dc/dXE9iT+ALOUuHXwLnAPDGMah6wLemW1ztxttxoa9PcInBntu+zVCyjZBqv7ItHtIQz1PAYDQQ+pspNpoBHcy2c1mTnDSAnKNsxuFbwjyDdBJYhzIssrwawiEpW7IoP+PI8QZ8I/6nBAG2w9knZDt8zxvInmcay1pRu9RrNR4B7U7ABd4kyDDgSfO+mwSDKcgzr5IuPPVwTtQ/CiVnZ7uHafaWyyTE0U8Dv87V4XtdoPgAaPeI+t6njmEg4NjD0V/UW7Q10B3Kkx31us8knR2GB/9xGWEmMdfv6uc3/AdiyV1Vuhw3sAAAAAElFTkSuQmCC';
var uvGrey = 'data:image/png;base64,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';
var uvOrange = 'data:image/png;base64,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';
var uvBlue = 'data:image/png;base64,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';
// Contact lenses
var hydratationBlue = 'data:image/png;base64,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';
var hydratationOrange = 'data:image/png;base64,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';
var softnessBlue = 'data:image/png;base64,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';
var softnessOrange = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAKI0lEQVRoQ8WaeXDV1RXHP+f+3nsJARISEVFQsI4jVlwGxVEHBEtdIkIWG6VT6zK4TNXa0Urr0lbUWrU4dKZjmanLWLeOGiUJiLhPQsSNxY6iBaUVLKtoVgjJe7/fPZ37ey8xCS/Jy4PBN/Ob/JHfvfd8773ne875np+wnz8tZYSvnGaECQZOBSYqjAGGA8NS0+8W2AlsAzZbZb01fBhRVkk1TftjgmQzWCsYgs+pKOcpnAGMAvKACEIrSoMIe7B44fyGACVX4RBgBKAorRg2CXwOvNMSob6gkobB2pMxAJ2P4VOGE+dshCnAiQiHqeIrfImywbhdNjRgacHQ3sMYSy6GfCxFCKMsjBM4RmCEKo0ifAS822aoz9vMN7KGRCZgMgKgZRyCcIINON0YZigcQXLRdYHlXx5swLCBr2gcaGE9lShHUZgQxkWViVaZKHACyWv3rSrLLdRHfP4ty2gcCMSAALSCQ/GZinKpwnRgp8AbgaXOi7BWFrNloEX6+78Wk08OkyxcJDAVGKlKnSrVXg7vSSW7+hvfJwAFoYKh+FyMcqW6KwOfBcp9rTHeL6qkeX8M7z1Wi8khl2MV/opyksAnwJNYXmIJjgQ03XppAYTGz2YYwh0IZQp7VXnReDyzqYGd42vp6GvCbEGFa07HYyjDiXCtCnMECiy8bCx39gUiPYDZDLeG+wSKUbapUGkM1TSwQ2rxszUy03F6EWNshDKBS4HR4ebFuE8q2d17jn0AhHc+wUzgDwpbVXnOeLwsi9mcqQEH4j0tZ5wNQr+4xLGdCPcT4ZXePtEDgM6kMPCY6hluVkdv8LgxLD3YxnduQAjCMktgrkBTAA+3BdTlL+Wbzne6AIT0NpbJFq4WYbYoCwh4Rl5m64HY0Wzn0HLG2oArRLgZeFsMD3MS78h8rJvzOwDlHE7A5Spci7BZ4lycCQ9na1im43Q6EYoYo5angeNUWWBiPCopFvwOQCmXANcrDEkIc2ONrD8YDpsJkC+nkzu2gGmesECErVgWSQ1Lu05AKygiETrtDBFepZ3fsZz4gabKTIxN946j2MYK8gvi3CWGGaK8SpT5Usne8AS0jBK13IKwN4AHotXU7hNokrlQDpW0f1/A/NnMNoZbBNp85f5oDfWdABagnG/hDdPB3bKcljSRMp/cMGcZ0pHgfzlxtsnr7Ml2V7MZ5xwa5TZVzlJY5lXze3H5vApPohSK8IRU8UTaYyzncBtQboRzLXxshDUoWxDawsejjTb8BktQFMEnF18qiWdjaH9j/BKuNsI1QLOLEZIo41zP8pAKawPDothiVqUFUEFB4DPVaMgGLqdvFNiswka1bFTDFyjNquxG2W2VplguX6fmCoDw2bQLf/x04p00OFiAWsJUK9wgMCFQbpWghDtFmKvwVJuwaHhV16I95tZribKDH6hhJa4wESyKFcFXTRoXFirJx3F051/H1V9CeFpfYFm9N+C9IaexPRsQWsYoLDeo8FOX+Lkr9LTClDBwbeHRvvL5MNkqZqTm8jzK5G7lYiab6Nii3V01VVpQdonhrYSyJBrwuSylLZNJQsJJBtxrVLhVYYXYUla4+lWEB6WK5/qbSCsYZn1uN8rlCmMzXTTNe4HAfy2sVctSz1I7mIivZcwBblcl7gBsFNiEslBqeGUAADHfZ4qn/Bk4BVI1b/ZIOoD3RXkGS7V0y3H6taOEC1WY5yKzA9AqQh2wUKp4u9+B7hqdRx5D+bsqFwKFGdru/ENQ4ggtCAk0FAGcchEB6qzwF6+RZZlE/0QpMzy4BTjbAdAwshkWDASg09gUlV1HUkYZsCyFMF5EBbYjrLVKg4EjFX6Y2gRHtyvEch2T2DWQc4cAlHkI52cFQGcx0hruFeEKF9gyOIXOctCxkyuI9iq8rsobIqE6cYGjZscqJuDxgZy6N4CMr1CnoVqBh0+5wi9QzskAQO9XHBCX03+uQpUq2wVOFzheoswFdkhlSMtpf72vkFPLNjgaHciJu8+mFYzB51JVrgeOyQKEG+Los16hxgobjeVkI3zUBGsK+1HsNOnEvxanLWkpq1SICdw/EI32NlJLONEKVwhclYrOJgsgzj/esfCsZ3kPQxEdrE+Xj3XdgDLmqPJbgVYH4AmFaaI81F8gS5teJKPzRGu4VQjVutFALAsQ7iRW+vCbaBPr+mOiboFsniorJSjlRoGbBP6JsEj6SCX6MspVTG35jMr1uEmUcuAohCjKYE9jpwgvkscd8uy+2XC33R+FhoXX5ao8LokSfuwJDymsN8rfpIb6we5gSjfNC3yKjeUyJFTYMo0Rncs1ItSK5Vc0s72vU4iXM9mzXC/KpMCdfJhOwws4EUl5NFLDY4MF0I2diogzGuFkq5wjwpnAhFSwSjftXsc4qnygwmuesJpGNtKPcKZlXKXKVQiNoqH/QVDKvQIzRXgX4YH91jtnUkgOR6OMd9K71dA3XK/ARV0X+lwm22yUXU7N9i1fRWyY1HXJJWl9rph8m8NdBs5FeE2qmBcCSJQwNSLcrpBnLQsjS1iS7SmkXdiJZe0MI5YE0JFAc5QmttE8kJrdg7pLma5wG8oQMWHqU5MsKV3DIsF8FS4Q5c3GKPcUVtLyfdW++9B1MpWPkcsfVblA4K2WKPe4hkhXHpMqmF1QOiJQ5m1ppu7o2l5NigN5LIOYK9SGCpngWMelIQKLpDr0227CVgUFNs41kkxTN4jh5zSwNZPscBC2ZPWqkzw1xkso41R5pN3jqaGL2d4TgJNNPmaKWm4EfiTKQjye2l+HzsriboOcUo3HZS7/V2WJhcciW1jV6Ts9UuGWWYzM85hm4JeOVkV4DDn4ynQXLZczDuUiVa52KoQjGC+gvrvkmVZeDxLMNHCbwA6UF/BYdrAVaqdMEzATYY7CkQJ3E2VZv/J6t4A0zMZDteInqSLkeRJUD6ZuzfbqpMTc0SglKBWu56yw3HVpZAmtveftt8WU6tLMAppEeQ6fR9hDK7W4ojxtzyprw0E2TSdnfBGHEfAzdR06GKJKlVH+NKgWUxgbOvtkhosVrnQdeISPE3BTrJ0vZDmuID9gv4YKCobHOcMT7iRZaq6z8A8vyotUsmdQTb4e0a+CQ4MOzhShVIRprpISYYWvLIt0sLa/vD0TdE7vDHwmeYZp6lIEOCws8uF5L8qKrNusPUC43CbC8bg+rlCc+mRgq8KnRliXENZ1KJuHDaLRjeU4J4tgOEU1PN1ClO2qvGk8PmxN8Fn3VlJfm5GJohCODQuJcYwMAs4WOEucLiQUOY1U4T/uIw6jfJ3JpwbW7bJwnIGjNalW7AA+CSwrvRzqOIHWgZSJTkAZA+h1rYqCRAhkigjHYhmPhBqPm69J4FuE9u4fe6gyNASs4XtOmXBV2NcKH1jl9UiM1a5hkcm16/5OVgB6ZYgjfGGysZyOMMEV2i6fSt3lrs9tIKRAd+3WAWvcJzcRYfX+fm7zf3OBT0w5LYy/AAAAAElFTkSuQmCC';
var breathabilityBlue = 'data:image/png;base64,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';
var breathabilityOrange = 'data:image/png;base64,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';
var fatigueBlue = 'data:image/png;base64,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';
var fatigueOrange = 'data:image/png;base64,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';
var basicsBlue = 'data:image/png;base64,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';
var basicsOrange = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAANEklEQVRoQ72aC5CUVXbHf+d+3T1PhocMqLCBIrAqCBhR3CiypHxEROYBO6aSVXGzG0zUxMR1a3VNXNB9Wbomu4pVkl0VtHTNiDMMIiJYQRE3gsRVskIUH6ggOjycGZhHf/3dk7q3u4eZ3p6ZHkj5VVFQVN/7nXPuuf/zP//zCSf4aA3DUso5RjjdwAzgTIUxwBCgPLP9EYHPgH3AHqvssoatMWWbNPLFiZggx7NY6yghxQyUSxW+BowCSoFQhM9QDllIkv7jnoQoZRiGoAwFhqO0YfhQ4B3gldYYm4fWc2iw9hTsgC7B8HuGkGQ2wixgKsJoVToV3kTZo8IBLM2BoTVlCWOxtAOpFAmEEjGUYRkqcArCOIGxuH8r7SK8AbzabthcuocDsp2wEGcKckBrOQlhio2YaQwXqWUYwn6Fd1R4O4LtiRgfMoV2WYLt78WZQJQmU4xPWCZhOEfVp55Lu4OqrLOwOZZip6zl8EBODOiA1lFJigux1KlwPvCZKo3GsJZOdsk6ugZ6Sb8OzaWCIs62cIXAhe7uKLyqlqagiN9KPc39re/TAQWhjjJSLFTlWmCiwqaU8JNEJ++fqOG5RulciihmAsoPFOYAuwVWYFlFEw4ENJ8jeR3wxldRjvADhFqFFoXHTJzHaOYom4j62vB4T8O/cw4BlZTZkKsF/6fSwrPGcntfTuR3oIoh1vBjgbnALoGnSLJRnmP/8Ro4mHV6OSeTYJ7CXwLjVHnaJPix1HMkd58/cMDnfMg84A6F963wWBDxvDR5HP/SHq1jTJTiYqN8A5gkwk+J8VzunejlgM5jeBRwoTH8k8N1geXEeV7q2Vuo5Z/XUV4ZcRKW4Rjifp0lxHC4OeDgqDxR7GtvrWI0hksU/h5ot/BAe8RLFWs4kF3T7YDOIM5YzrXCXwv8ucLdJsnThaSNh8Y3GYllZKRMlIDJWMY57PcvUjow7DHC/2L5AGEf0zkwEOT6pZdzsk3wDYHvq7LFBDzINF7Jrj3mwAJOIeIaFRYpbDdxbpR6WvqFwDRSxenyJ1cVKJdpmk6MACIf+/RjgBh4yN3pAcHy7O6QgxPXkRwIELSOoYQ8oDBblftNgn/P2nbMgRquBK5XKAmFaxOHeVc2kerXgTrKSTET5bvAeR5JHIYL/2nhbRU+d+tFGWUsZ4ur4Mo0hDLPieC2IM7mfJez53t1DjGGM0mVFSIcxPKgrGaN39sfUx0jCP2lvUiE5+nknxkgMlrLGRaqRZkvwslW+S9V1ltlRzzGfjo4SkeGC5WQ6CihokQZFsFXxVIn4hHuY1VWR8qqRJOnEnkfH5i5JGyC7wr+fS8TZ4nU05F2oJZqtdyM0BHBz+KNbOo38tWc55NH+DNVIlWetMrWWBE7gRaaESoZTpIJGDrbI5pLWzkkm+jUKoYQYxoRsxT+CkOglhcNPCGrea3f99YyXZUlAkUp5afx1WzOOnCPKnNUeMF0cresozXfRv4oK5hqDd8R4euOdarwlEnyxNK1tCwBq3MoZgRTbcSlCKehdAIfGtjUnOAth0Lq7sQ8hhL3980FYqgqLxnLr2hlR1+p66q1LeJOwSPT2qCRfxHH51VYgSKiPCKrachr/GLiHOBUG/E9EeajfGwNDwcxnnRHmV2jtZxplcUC34EMCuEdfTyKeLRnqrjUtUmfTt8ExqrynAm4h5Hsk+X52WiqlkVGWQwcFbhSwlouCSz3irAF4UFp4H/yOlDLKKvUCNzjWKNV7goS/Kan8W5dVMvtolwPnJqzz/siLJMG7ut1QesoiUIWGrjN0WsrfL8joqG8j8LZVcuZMeV6gfMj5RaJqrldhG+L8hAJlvWFCFrNZAw/UuVyFX5uIlbSxDu5EKg1/FLhhgx09rQ1yjhwUy8HQMIazg6U60S4VuANLH8rfVxqraPcJrnB2azwS5dCjwGTUX7Bn/B4X8XFVWli/p7c7Y5PhYdMjFW5pV1r+GHGgcqcE2gWWCaNLM05gUob8hcCf4cQF7gD2CANHMybCa5o/o5vATdb2Ca2hpdFPN7/QhpY3SeU1RG4AmVTLBTlOpRWFRpCWFPcyHvZdWEtlwXqT+CKnL3Wi7Isi98e/RYw1lpqRP1FrsgGBTgk9b4Q5ofVKqo0TXfKnQO7UX4vcL+sZmO/MJZFjxiLFWq8EcJ6Y1mdRY+2WkaVKxcpLAT+KLPfR1ZYE4RslGfZ69FsCKdhuEKFK1BiCo0mxfIsmvVrRw1zFG4EzncOtCmssZZl8Sa29LewG2nShe8ahauBkR49hKccXBKlqy+G8ZEw019sZWvC8iEpIoThFDMe9Y3SfKBV4YkjcVYW2tSHVVxgDDf4omZrUIUVxrBMnmFbIQ74yM9juI1xpcA/Ir45P6zKb0zAM1h2EfdpmU6DFgylxP3vlDkI31TLZOB3Fh4KUqwrpP/tDuACzrXWO7Do+B1wMa6jiJDTLHxb0injOE6zCLuw7LDuRNxhuLosnI0yVeEkDwLQYAJ+xRDeWfooSVcECw5ejgODTqFeKOIqbwVjI8OZopwjwrnABE+lHY1OP4nM3594SgwvIHzAF+x19KJQw7uBIieF9gm8CjwgA3CgPlHhmABwKsr4CL7iCB7KSE8lhFZPO2BfBO8lEuymnnAgGt3n+6q52DU5IkxxdWAbQlsU8W+xJpoGG418v/coM4xy1+B0CF0lSVrooH0gel7ouz35hJtEiTkHHlGYaeG+4CweyVfI1PGgw5QSUYqlFKUI8WnRRpx9uXSiYENcP2E5xe9paKeLdqfSYWnnPMK8tizBRG9wlRFuUmWnRDXcKPAPovw6H5XwXHwBYyLlrECZCPwx6fSodBQ6FB7qWcgKNd79rquKaTFHY4TJIrxnLR+osNsKu+PKHhpp+QOqcoxKXKfKryWs5uJAuNffgzxkzgu5oecdd2X4jbuYDmmcyry+0/B02TN8OhjDu+GwilOt4SpJC1nDnISSYbBWhB8S4+Hc0+0mc8oFkeGWNJ2G/3AQKMJyaWBFL5RZgrFvsljUs8giYL8jc5FlS1z5mCIOSH23Cj0oP7SOBEmvPIyzllkiXn042R2OCjeb6SzPTSOtplaFbyGoKIt8QxPVcJfghaQNpos7cmVDreEqhTvByyQphVdcIxMor5yovq+1fNXL9MIlKF8hXSec8neHNPJ4r2A6HbXYqxOXirBJGviedyCs5sKYcJtClwhLpIE3ey1cQJVabgEqFLaIMkHTc4CtJmAbATup9w1GXv0y91icDNP+FqMTKaYbYZYYzkJRdQExntxZlHtzmytNc6BbUS/V3+fIZ7apd3m+RJXZjheZJD/v2dSHVczOcI+pIiyMlPMCqAZGAzsiZUNgeBfLIVIcodQXp2SWUapjsi0UHy2mvMzluvHzgSleRIBhVtlpLWtiRWzVkDUoByLlgXgTGzxtyTT1FPt+5DKBF1vj3Om4U7eskqqiyhjfSY0IhUU9ZRWdzxQb42pxHZlwgePqWsMM61o6PCGrFOE1q7ym8LaN+Cge0Eycoz76IWUuPazrO4SvOeHMpaMzBMMTdLHZcSHXYmrIepeixrIy29T0kFUeBa9EPCiN/t6mZRXvZR1DbZK/cRdJ4eWewlZ3YYo8k/zIRdYreRMocjgeWeaI+mhOc+wUfO/guE02pdx73P91oHyg8KIx1AOf0smRpesIvSDgTipiLJYWvuBItvD1ELZmOG2oM2BlFvmOOeA6nbeYZSOu91EWfkYXq7LSYlb+zq2mvsg1M9xV3dBSYQLGiDLG02bNNPXiDd9v4GMC9ncmOVBcwv58dMIHq4d875XqIhai3GrxutPDsU/Ylh1B9RJ3W+czsjTg6ybdLDhx934sGwajTDtxt6yLilJDCUFG3I0Ijwht5YdpHQx5cwo1oZcrnQrRbi3/GkTpdMtmTl55PQqZZ+BWN0GMhFVBjI2DUagHVQz6+LFTpqPAt6cOwicKLCXO2n7l9R73wXX+Tq1w2vwegSdJsrYQpfr/xfj0gONi4EqFMxTWuSmNNNGWu3+/I6bMlMahzOcirCTG41/GiIkUV6lyDXjFrsEoPxnUiKkbe92czLBQYdGXOeQDX7B2W1gRxHm6vyJZ0Jg16uJPxVDl1DBHoZ06nFLWxrr477501EJTKTOdPB0nmEGtK46q/FaF+iDOy8c9Zu1FJdKi1hm4Oa4wN9PX7lVhu7G8njS8e1yDbphhlclGmKSuLxBaVNloAra2hbzdc5TUV0AGPIHui+0K1zhGRhGz3UkInIX47yM+VfjEfWpgXGEytGB9BW4nyAi0kVckElgqML6PGJn51GC6o8+Cn37ucAw3KOIlptBWyPipVyUu9MgzVXtEFHpHHAWehGU8whBx0orQIurl+aPWkYh0ExFXKBJhBMpoTbPadgcOiqcgL8QSvH48nV3BJ9CXg/5zG+FcY5mJcLqkmxKnTDui1/25jW8/Ya/i1e/t7pObmPD6idLx/wNEku5bYZYThwAAAABJRU5ErkJggg==';
// Solutions
var disinfectGrey = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zOC41IDIwQzM4LjUgMzAuMjE3MyAzMC4yMTczIDM4LjUgMjAgMzguNUM5Ljc4MjczIDM4LjUgMS41IDMwLjIxNzMgMS41IDIwQzEuNSA5Ljc4MjczIDkuNzgyNzMgMS41IDIwIDEuNUMzMC4yMTczIDEuNSAzOC41IDkuNzgyNzMgMzguNSAyMFpNMjAgNDBDMzEuMDQ1NyA0MCA0MCAzMS4wNDU3IDQwIDIwQzQwIDguOTU0MyAzMS4wNDU3IDAgMjAgMEM4Ljk1NDMgMCAwIDguOTU0MyAwIDIwQzAgMzEuMDQ1NyA4Ljk1NDMgNDAgMjAgNDBaTTE2Ljk0NCA5LjUzOTA2QzE3LjM1ODIgOS41MzkwNiAxNy42OTQgOS4yMDMyOCAxNy42OTQgOC43ODkwNkMxNy42OTQgOC4zNzQ4NSAxNy4zNTgyIDguMDM5MDYgMTYuOTQ0IDguMDM5MDZDMTYuNTI5OCA4LjAzOTA2IDE2LjE5NCA4LjM3NDg1IDE2LjE5NCA4Ljc4OTA2QzE2LjE5NCA5LjIwMzI4IDE2LjUyOTggOS41MzkwNiAxNi45NDQgOS41MzkwNlpNMjkuNzQyMyAxMC41NTE3QzMwLjAzNTIgMTAuODQ0NiAzMC4wMzUyIDExLjMxOTUgMjkuNzQyMyAxMS42MTI0TDExLjAwNCAzMC4zNTA3QzEwLjcxMTEgMzAuNjQzNiAxMC4yMzYyIDMwLjY0MzYgOS45NDMzIDMwLjM1MDdDOS42NTA0MSAzMC4wNTc4IDkuNjUwNDEgMjkuNTgyOSA5Ljk0MzMgMjkuMjlMMTYuMTg5MSAyMy4wNDQyQzE1Ljc4OCAyMi40Mjg5IDE1LjMyMjEgMjEuODU4NSAxNC44MDA5IDIxLjM1MzJDMTQuNDc1MyAyMS4wNDQ2IDE0LjA1ODkgMjAuNzIxMiAxMy41ODA2IDIwLjM0OTZMMTMuNTgwNSAyMC4zNDk1TDEzLjU4MDUgMjAuMzQ5NUwxMy41ODAzIDIwLjM0OTRMMTMuNTgwMyAyMC4zNDkzQzEzLjUwMjIgMjAuMjg4NyAxMy40MjI2IDIwLjIyNjggMTMuMzQxMyAyMC4xNjM1QzEzLjIzOTIgMjAuMDgzOSAxMy4xMzUyIDIwLjAwMjQgMTMuMDMwMyAxOS45MTkxTDExLjcyOTQgMjEuMjJDMTEuNDM2NSAyMS41MTI5IDEwLjk2MTYgMjEuNTEyOSAxMC42Njg3IDIxLjIyQzEwLjM3NTkgMjAuOTI3MSAxMC4zNzU5IDIwLjQ1MjIgMTAuNjY4NyAyMC4xNTkzTDExLjg4OTIgMTguOTM4OUMxMS44MDM0IDE4Ljg1NjYgMTEuNzE5MyAxOC43NzMxIDExLjYzNzQgMTguNjg4NEMxMS4xMTQgMTguMTQ2OSAxMC42MzQ2IDE3LjUwOTIgMTAuMzk5NiAxNi43NjY1QzEwLjE1NTUgMTUuOTk1NCAxMC4xOTIxIDE1LjE2MzUgMTAuNjE1NyAxNC4zMDNMMTAuNjMyNSAxNC4yNjg4TDEwLjY1MjcgMTQuMjM2NUMxMS45MjExIDEyLjIwODIgMTQuMjAyNSAxMS44Nzc5IDE2LjA4MDIgMTIuMDA5OEMxNy4yNDI1IDEyLjA5MTQgMTguMzU5NCAxMi4zNTYgMTkuMTg1OCAxMi41OTEyTDE5LjcwNDYgMTAuODk4NkMxOS44MjYgMTAuNTAyNiAyMC4yNDU1IDEwLjI3OTkgMjAuNjQxNSAxMC40MDEzQzIxLjAzNzUgMTAuNTIyNyAyMS4yNjAyIDEwLjk0MjEgMjEuMTM4OCAxMS4zMzgyTDIwLjYxNzcgMTMuMDM4M0MyMS43OTc2IDEzLjQ0MDggMjIuODg1NiAxNC4wMzggMjQuMTg4NCAxNS4wNDQ5TDI4LjY4MTYgMTAuNTUxN0MyOC45NzQ1IDEwLjI1ODggMjkuNDQ5NCAxMC4yNTg4IDI5Ljc0MjMgMTAuNTUxN1pNMTguMjYwMyAyMC45NzNMMTcuMjcgMjEuOTYzM0MxNi44NTAyIDIxLjM1NTcgMTYuMzcyMiAyMC43ODcgMTUuODQxOCAyMC4yNzMyTDE1LjgzNjMgMjAuMjY4QzE1LjQ1MTUgMTkuOTAyNiAxNC45NjU0IDE5LjUyNTQgMTQuNDkxOSAxOS4xNThMMTQuNDkxOSAxOS4xNTc5TDE0LjQ5MTggMTkuMTU3OUwxNC40OTA0IDE5LjE1NjhDMTQuNDE0NCAxOS4wOTc4IDE0LjMzODYgMTkuMDM5IDE0LjI2MzcgMTguOTgwNkMxMy43MDI1IDE4LjU0MyAxMy4xNjA5IDE4LjEwNjMgMTIuNzE1OSAxNy42NDU5QzEyLjI2ODcgMTcuMTgzMiAxMS45NjUzIDE2Ljc0MjUgMTEuODI5NiAxNi4zMTM5QzExLjcwNTggMTUuOTIyNSAxMS43MDc1IDE1LjUwMDIgMTEuOTQ1MSAxNC45OTkzQzEyLjc2MzQgMTMuNzI1NCAxNC4yNzYyIDEzLjM4NjggMTUuOTc1MSAxMy41MDYxQzE3LjUwMTQgMTMuNjEzMyAxOC45NTE3IDE0LjA3ODIgMTkuNjg4MyAxNC4zMTQzTDE5LjY4OTEgMTQuMzE0NUMxOS43Njc1IDE0LjMzOTYgMTkuODM3OCAxNC4zNjIyIDE5Ljg5OTIgMTQuMzgxNEMyMC45NDIyIDE0LjcwNzggMjEuOTAyOSAxNS4xOTUgMjMuMTE4NCAxNi4xMTQ5TDIxLjcxMzkgMTcuNTE5NEMyMS4zODggMTYuMzI4NCAyMC4yOTgxIDE1LjQ1MzEgMTkuMDAzNyAxNS40NTMxQzE3LjQ1MTkgMTUuNDUzMSAxNi4xOTQgMTYuNzExIDE2LjE5NCAxOC4yNjI4QzE2LjE5NCAxOS41NTcyIDE3LjA2OTMgMjAuNjQ3MSAxOC4yNjAzIDIwLjk3M1pNMjYuNTQgMTguMDI2QzI2LjMzNDUgMTcuNjY2NCAyNS44NzY0IDE3LjU0MTQgMjUuNTE2NyAxNy43NDY5QzI1LjE1NzEgMTcuOTUyNCAyNS4wMzIxIDE4LjQxMDYgMjUuMjM3NiAxOC43NzAyQzI1LjUxNjcgMTkuMjU4NSAyNS43MzE0IDE5LjY2ODcgMjUuODU5NyAyMC4wODQzQzI2LjE1MDYgMjEuMDI2MSAyNi4xNzM3IDIxLjI2NDYgMjYuMjI3MyAyMS44MTc2TDI2LjIzNjMgMjEuOTFDMjYuMjY3MyAyMi41NTQ5IDI2LjI2NjggMjMuMzAxNiAyNi4yMzU2IDIzLjg3NjFMMjYuMjM1NCAyMy44Nzk5QzI2LjE4MTQgMjQuOTc4MiAyNS42MTM4IDI2LjAxMDkgMjQuNzE3NCAyNi43OTk2QzI0LjI3MzUgMjcuMTU2NSAyMy44OTg1IDI3LjM3NDggMjMuNDggMjcuNTA1OEMyMy4wNTI1IDI3LjYzOTYgMjIuNTI4NyAyNy42OTggMjEuNzY4NiAyNy42NjE0QzIxLjE3MjEgMjcuNjMyOCAyMC41OTA3IDI3LjM0MDUgMjAuMDkwNyAyNi45MzUxQzE5LjU4ODYgMjYuNTI4MSAxOS4yNDQ1IDI2LjA2OCAxOS4xMjA4IDI1LjgzNjNDMTkuMDcwOCAyNS43NDI2IDE5LjA0NjEgMjUuNjk1NSAxOS4wMjg5IDI1LjY2MjhMMTkuMDI4OSAyNS42NjI4QzE5LjAwMTMgMjUuNjEwMiAxOC45OTMzIDI1LjU5NSAxOC45MzEyIDI1LjQ4MzFDMTguNzMgMjUuMTIxIDE4LjI3MzQgMjQuOTkwNiAxNy45MTEzIDI1LjE5MTdDMTcuNTQ5MiAyNS4zOTI5IDE3LjQxODggMjUuODQ5NSAxNy42MTk5IDI2LjIxMTZDMTcuNjc0MiAyNi4zMDkyIDE3LjY3NDkgMjYuMzEwNyAxNy42OTQzIDI2LjM0NzZMMTcuNjk0MyAyNi4zNDc3QzE3LjcwODYgMjYuMzc1MSAxNy43MzMyIDI2LjQyMjEgMTcuNzk3NSAyNi41NDI1QzE4LjAyNTMgMjYuOTY5NCAxOC41MDU0IDI3LjU4MDkgMTkuMTQ2IDI4LjEwMDNDMTkuNzg4NiAyOC42MjEzIDIwLjY2ODEgMjkuMTEwMyAyMS42OTY2IDI5LjE1OTdDMjIuNTYxNSAyOS4yMDEzIDIzLjI3NTggMjkuMTQxNCAyMy45MjggMjguOTM3M0MyNC41ODU2IDI4LjczMTUgMjUuMTI4OSAyOC4zOTUxIDI1LjY3MTIgMjcuOTU3M0wyNS42ODI4IDI3Ljk0OEwyNS42OTQgMjcuOTM4MkMyNi44Mzk0IDI2LjkzNiAyNy42NTUgMjUuNTQwOCAyNy43MzM1IDIzLjk1NTVDMjcuNzYyOCAyMy40MTU2IDI3Ljc2NyAyMi43NTMxIDI3Ljc0NjggMjIuMTQwM0wyOS41NDU0IDIxLjkwODRDMjkuOTU2MiAyMS44NTU0IDMwLjI0NjMgMjEuNDc5NSAzMC4xOTMzIDIxLjA2ODdDMzAuMTQwMyAyMC42NTc4IDI5Ljc2NDQgMjAuMzY3OCAyOS4zNTM2IDIwLjQyMDdMMjcuNTcxMiAyMC42NTA1QzI3LjUxMjggMjAuMzg5MyAyNy40MjcyIDIwLjA3NjUgMjcuMjkyOSAxOS42NDE2QzI3LjExMTkgMTkuMDU1NSAyNi44MjM1IDE4LjUyMjEgMjYuNTQgMTguMDI2Wk0zMC43MTIxIDI4LjA2NjRDMzEuNTQwNSAyOC4wNjY0IDMyLjIxMjEgMjcuMzk0OCAzMi4yMTIxIDI2LjU2NjRDMzIuMjEyMSAyNS43MzggMzEuNTQwNSAyNS4wNjY0IDMwLjcxMjEgMjUuMDY2NEMyOS44ODM2IDI1LjA2NjQgMjkuMjEyMSAyNS43MzggMjkuMjEyMSAyNi41NjY0QzI5LjIxMjEgMjcuMzk0OCAyOS44ODM2IDI4LjA2NjQgMzAuNzEyMSAyOC4wNjY0Wk0yMi4xOTg5IDIzLjU2NjRDMjEuNzg0NyAyMy41NjY0IDIxLjQ0ODkgMjMuOTAyMiAyMS40NDg5IDI0LjMxNjRDMjEuNDQ4OSAyNC43MzA2IDIxLjc4NDcgMjUuMDY2NCAyMi4xOTg5IDI1LjA2NjRDMjIuNjEzMSAyNS4wNjY0IDIyLjk0ODkgMjQuNzMwNiAyMi45NDg5IDI0LjMxNjRDMjIuOTQ4OSAyMy45MDIyIDIyLjYxMzEgMjMuNTY2NCAyMi4xOTg5IDIzLjU2NjRaTTE5Ljk0ODkgMjQuMzE2NEMxOS45NDg5IDIzLjA3MzggMjAuOTU2MyAyMi4wNjY0IDIyLjE5ODkgMjIuMDY2NEMyMy40NDE1IDIyLjA2NjQgMjQuNDQ4OSAyMy4wNzM4IDI0LjQ0ODkgMjQuMzE2NEMyNC40NDg5IDI1LjU1OSAyMy40NDE1IDI2LjU2NjQgMjIuMTk4OSAyNi41NjY0QzIwLjk1NjMgMjYuNTY2NCAxOS45NDg5IDI1LjU1OSAxOS45NDg5IDI0LjMxNjRaTTE3LjY5NCAxOC4yNjI4QzE3LjY5NCAxNy41Mzk1IDE4LjI4MDQgMTYuOTUzMSAxOS4wMDM3IDE2Ljk1MzFDMTkuNzI3IDE2Ljk1MzEgMjAuMzEzMyAxNy41Mzk1IDIwLjMxMzMgMTguMjYyOEMyMC4zMTMzIDE4Ljk4NjEgMTkuNzI3IDE5LjU3MjQgMTkuMDAzNyAxOS41NzI0QzE4LjI4MDQgMTkuNTcyNCAxNy42OTQgMTguOTg2MSAxNy42OTQgMTguMjYyOFpNMTcuOTA1NCAzMC41ODJDMTcuOTA1NCAzMC45OTYyIDE3LjU2OTYgMzEuMzMyIDE3LjE1NTQgMzEuMzMyQzE2Ljc0MTIgMzEuMzMyIDE2LjQwNTQgMzAuOTk2MiAxNi40MDU0IDMwLjU4MkMxNi40MDU0IDMwLjE2NzggMTYuNzQxMiAyOS44MzIgMTcuMTU1NCAyOS44MzJDMTcuNTY5NiAyOS44MzIgMTcuOTA1NCAzMC4xNjc4IDE3LjkwNTQgMzAuNTgyWk0xNi40MDU0IDE0Ljk3MjdDMTYuNDA1NCAxNS4zODY5IDE2LjA2OTYgMTUuNzIyNyAxNS42NTU0IDE1LjcyMjdDMTUuMjQxMiAxNS43MjI3IDE0LjkwNTQgMTUuMzg2OSAxNC45MDU0IDE0Ljk3MjdDMTQuOTA1NCAxNC41NTg0IDE1LjI0MTIgMTQuMjIyNyAxNS42NTU0IDE0LjIyMjdDMTYuMDY5NiAxNC4yMjI3IDE2LjQwNTQgMTQuNTU4NCAxNi40MDU0IDE0Ljk3MjdaTTI0LjY5ODkgMjIuMzM1OUMyNS4xMTMxIDIyLjMzNTkgMjUuNDQ4OSAyMi4wMDAyIDI1LjQ0ODkgMjEuNTg1OUMyNS40NDg5IDIxLjE3MTcgMjUuMTEzMSAyMC44MzU5IDI0LjY5ODkgMjAuODM1OUMyNC4yODQ3IDIwLjgzNTkgMjMuOTQ4OSAyMS4xNzE3IDIzLjk0ODkgMjEuNTg1OUMyMy45NDg5IDIyLjAwMDIgMjQuMjg0NyAyMi4zMzU5IDI0LjY5ODkgMjIuMzM1OVoiIGZpbGw9IiMyQjJFMzEiLz4KPC9zdmc+Cg==';
var hydrationGrey = 'data:image/svg+xml;base64,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';
var rinsingGrey = 'data:image/svg+xml;base64,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';
var comfortGrey = 'data:image/svg+xml;base64,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';
var cleaningGrey = 'data:image/svg+xml;base64,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';
var sensitivityGrey = 'data:image/svg+xml;base64,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';
var icons = {
    'polarized-grey': polarizedGrey,
    'polarized-orange': polarizedOrange,
    'reading-grey': readingGrey,
    'reading-orange': readingOrange,
    'uv-grey': uvGrey,
    'uv-orange': uvOrange,
    'uv-blue': uvBlue,
    'hydratation-blue': hydratationBlue,
    'hydration-grey': hydrationGrey,
    'hydratation-orange': hydratationOrange,
    'softness-blue': softnessBlue,
    'softness-orange': softnessOrange,
    'breathability-blue': breathabilityBlue,
    'breathability-orange': breathabilityOrange,
    'fatigue-blue': fatigueBlue,
    'fatigue-orange': fatigueOrange,
    'basics-blue': basicsBlue,
    'basics-orange': basicsOrange,
    'disinfect-grey': disinfectGrey,
    'comfort-grey': comfortGrey,
    'cleaning-grey': cleaningGrey,
    'sensitivity-grey': sensitivityGrey,
    'rinsing-grey': rinsingGrey,
};
var FeatureIcon = function (_a) {
    var name = _a.name, _b = _a.color, color = _b === void 0 ? 'blue' : _b, _c = _a.size, size = _c === void 0 ? 24 : _c;
    var source = icons[name + "-" + color];
    if (!source) {
        console.warn("There is no icon with name '" + name + "-" + color + "'");
        return (React.createElement("span", null,
            "No icon found with name ",
            name,
            "-",
            color));
    }
    return (React.createElement("img", { className: "icon icon--image icon--" + name, src: source, alt: name, style: { display: 'inline-block', width: size, height: size } }));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1y =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M18.75 14.004l-4.787.957M14.438 9.531l-2.26.955a1.42 1.42 0 01-1.122-.016 1.478 1.478 0 01-.781-.83c-.28-.72.023-1.537.706-1.9l2.259-1.127a1.961 1.961 0 011.594-.094l4.639 1.828"
});

var _ref2$X =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M5.2 15h1.6l3.049 2.326a.83.83 0 001.15.09l4.26-3.518a.842.842 0 00.129-1.164l-2.347-2.609M10.736 7.9l-.247-.2a1.787 1.787 0 00-1.725-.221L5.194 9"
});

var _ref3$v =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M1.39 15.75h2.66a1.14 1.14 0 001.2-1.072V9.321a1.141 1.141 0 00-1.2-1.071H1.39M22.61 15.75h-2.66a1.14 1.14 0 01-1.2-1.072V9.321a1.141 1.141 0 011.2-1.071h2.66"
});

var _ref4$e =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z"
});

function SvgBusiness(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1y({
      className: "business_svg__icon business_svg__icon--business",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1y, _ref2$X, _ref3$v, _ref4$e)
  );
}

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1x =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.21a2.25 2.25 0 012.25-2.25h16a2.25 2.25 0 012.25 2.25v14a2.25 2.25 0 01-2.25 2.25h-16A2.25 2.25 0 010 18.21v-14zm2.25-.75a.75.75 0 00-.75.75v14c0 .415.336.75.75.75h16a.75.75 0 00.75-.75v-14a.75.75 0 00-.75-.75h-16z",
  fill: "currentColor"
});

var _ref2$W =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.235 0a.75.75 0 01.75.75v4.5h-1.5V.75a.75.75 0 01.75-.75zm0 6a.75.75 0 01-.75-.75h1.5a.75.75 0 01-.75.75zM14.485 0a.75.75 0 01.75.75v4.5h-1.5V.75a.75.75 0 01.75-.75zm0 6a.75.75 0 01-.75-.75h1.5a.75.75 0 01-.75.75zM.25 8A.75.75 0 011 7.25h18v1.5H1A.75.75 0 01.25 8zm19.5 0a.75.75 0 01-.75.75v-1.5a.75.75 0 01.75.75z",
  fill: "currentColor"
});

var _ref3$u =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 4.674,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref4$d =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 4.674,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref5$5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.72,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref6$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.72,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref7$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 15.326,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref8$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 15.326,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref9$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.5 24a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
  fill: "#fff"
});

var _ref10$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.25 19.5a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zm-1.25 0a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0z",
  fill: "currentColor"
});

var _ref11$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.707 20.876c.24 0 .36.102.36.306 0 .212-.12.318-.36.318H18.68c-.244 0-.366-.106-.366-.318 0-.204.122-.306.366-.306h.624V18.14l-.576.354a.31.31 0 01-.15.048.273.273 0 01-.216-.108.382.382 0 01-.084-.24c0-.116.052-.206.156-.27l.93-.576a.668.668 0 01.342-.108c.112 0 .202.034.27.102a.381.381 0 01.102.282v3.252h.63z",
  fill: "currentColor"
});

function SvgCalendarMonthly(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1x({
      className: "calendar-monthly_svg__icon calendar-monthly_svg__icon--calendar-monthly",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1x, _ref2$W, _ref3$u, _ref4$d, _ref5$5, _ref6$2, _ref7$1, _ref8$1, _ref9$1, _ref10$1, _ref11$1)
  );
}

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1w =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.21a2.25 2.25 0 012.25-2.25h16a2.25 2.25 0 012.25 2.25v14a2.25 2.25 0 01-2.25 2.25h-16A2.25 2.25 0 010 18.21v-14zm2.25-.75a.75.75 0 00-.75.75v14c0 .415.336.75.75.75h16a.75.75 0 00.75-.75v-14a.75.75 0 00-.75-.75h-16z",
  fill: "currentColor"
});

var _ref2$V =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.235 0a.75.75 0 01.75.75v4.5h-1.5V.75a.75.75 0 01.75-.75zm0 6a.75.75 0 01-.75-.75h1.5a.75.75 0 01-.75.75zM14.485 0a.75.75 0 01.75.75v4.5h-1.5V.75a.75.75 0 01.75-.75zm0 6a.75.75 0 01-.75-.75h1.5a.75.75 0 01-.75.75zM.25 8A.75.75 0 011 7.25h18v1.5H1A.75.75 0 01.25 8zm19.5 0a.75.75 0 01-.75.75v-1.5a.75.75 0 01.75.75z",
  fill: "currentColor"
});

var _ref3$t =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 4.674,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref4$c =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 4.674,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref5$4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.72,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref6$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.72,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 15.326,
  cy: 11.682,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 15.326,
  cy: 15.607,
  r: 0.621,
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.5 24a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
  fill: "#fff"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.25 19.5a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zm-1.25 0a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0z",
  fill: "currentColor"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.15 19.428a.986.986 0 01.575.366c.136.176.204.396.204.66 0 .364-.134.654-.402.87-.268.216-.63.324-1.086.324-.26 0-.51-.04-.75-.12a1.805 1.805 0 01-.612-.336.363.363 0 01-.138-.282c0-.088.024-.162.072-.222.052-.064.112-.096.18-.096.04 0 .076.008.108.024a.992.992 0 01.132.066c.168.112.328.198.48.258.152.06.318.09.498.09.264 0 .46-.052.588-.156.128-.108.192-.27.192-.486 0-.212-.068-.368-.204-.468-.132-.104-.338-.156-.618-.156h-.342a.27.27 0 01-.216-.09.351.351 0 01-.072-.216c0-.084.024-.156.072-.216a.27.27 0 01.216-.09h.24c.548 0 .822-.206.822-.618 0-.192-.058-.34-.174-.444-.116-.104-.276-.156-.48-.156-.292 0-.604.116-.936.348a2.89 2.89 0 01-.132.072.306.306 0 01-.108.018.233.233 0 01-.18-.09.37.37 0 01-.072-.228c0-.06.01-.11.03-.15a.523.523 0 01.108-.132c.168-.14.368-.25.6-.33.236-.084.476-.126.72-.126.416 0 .746.102.99.306.248.204.372.476.372.816a1.095 1.095 0 01-.186.612 1 1 0 01-.492.378z",
  fill: "currentColor"
});

function SvgCalendarQuarterly(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1w({
      className: "calendar-quarterly_svg__icon calendar-quarterly_svg__icon--calendar-quarterly",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1w, _ref2$V, _ref3$t, _ref4$c, _ref5$4, _ref6$1, _ref7, _ref8, _ref9, _ref10, _ref11)
  );
}

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1v =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.358 7.194a1.772 1.772 0 012.371 1.665v.581c0 .572-.276 1.11-.742 1.442l-2.899 2.071-.316 1.887a2.796 2.796 0 01-1.207 1.866.759.759 0 01-.11.06l-2.33 1.044a.75.75 0 11-.613-1.37l2.267-1.014c.273-.2.457-.498.513-.832l.368-2.195a.75.75 0 01.304-.486l3.151-2.251a.273.273 0 00.114-.222v-.579a.273.273 0 00-.364-.255h-.002l-4.2 1.5A8.75 8.75 0 003 11.626L1.23 13.1a.75.75 0 01-.96-1.153l1.77-1.473a10.249 10.249 0 013.118-1.78l4.2-1.5zM4.75 19.75h6.5a.75.75 0 010 1.5H4.752c-.452.002-.892.15-1.255.419l-.004.003-2.3 1.683a.75.75 0 11-.886-1.21l2.298-1.682c.62-.46 1.37-.71 2.142-.713h.003z",
  fill: "currentColor"
});

var _ref2$U =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.893 13.791a.75.75 0 01.465.954l-1.839 5.332a1.771 1.771 0 01-1.68 1.173H11.25a.75.75 0 010-1.5h3.6a.271.271 0 00.256-.176l1.834-5.319a.75.75 0 01.953-.464z",
  fill: "currentColor"
});

var _ref3$s =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 19a2.25 2.25 0 012.25-2.25h2.25a.75.75 0 010 1.5h-2.25a.75.75 0 000 1.5.75.75 0 010 1.5A2.25 2.25 0 019 19z",
  fill: "currentColor"
});

var _ref4$b =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 16a2.25 2.25 0 012.25-2.25H18a.75.75 0 010 1.5h-4.5a.75.75 0 000 1.5h3.114a.75.75 0 010 1.5H13.5A2.25 2.25 0 0111.25 16z",
  fill: "currentColor"
});

var _ref5$3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 3.25a.75.75 0 01.75-.75h1A2.25 2.25 0 0124 4.75V13a2.25 2.25 0 01-2.25 2.25H10.5a.75.75 0 010-1.5h11.25a.75.75 0 00.75-.75V4.75a.75.75 0 00-.75-.75h-1a.75.75 0 01-.75-.75zM6.75 4a.75.75 0 00-.75.75v1.5a.75.75 0 01-1.5 0v-1.5A2.25 2.25 0 016.75 2.5H10A.75.75 0 0110 4H6.75z",
  fill: "currentColor"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.035 7.315c.16 1.636.684 2.455 1.572 2.455.333 0 .636-.08.91-.24.278-.16.544-.533.8-1.12.163-.384.305-.62.423-.712a.598.598 0 01.383-.143c.273 0 .485.08.636.239.155.155.232.374.232.656 0 .67-.328 1.29-.984 1.86-.656.565-1.452.847-2.386.847-.875 0-1.638-.316-2.29-.95-.652-.638-1.041-1.602-1.169-2.892h-.868c-.082 0-.123-.059-.123-.177 0-.114.043-.258.13-.431.086-.173.16-.26.219-.26h.587v-.246c0-.2.01-.49.028-.868h-.841c-.082 0-.123-.057-.123-.17 0-.12.043-.265.13-.438.086-.174.16-.26.219-.26h.683C13.5 2.09 14.62.903 16.566.903c.857 0 1.596.221 2.215.663.62.442.93.992.93 1.648a.797.797 0 01-.219.567.705.705 0 01-.533.233c-.232 0-.403-.06-.513-.178-.105-.119-.21-.3-.314-.547-.132-.324-.29-.57-.472-.738-.182-.173-.492-.26-.93-.26-.5 0-.888.175-1.162.526-.268.351-.442.9-.52 1.648h2.202c.091 0 .137.06.137.178a1 1 0 01-.13.444c-.082.164-.155.246-.219.246h-2.044l-.014.67c0 .205.005.353.014.444h2.256c.091 0 .137.057.137.171 0 .132-.044.283-.13.451-.082.164-.155.246-.219.246h-2.003z",
  fill: "currentColor"
});

function SvgCardPayment(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1v({
      className: "card-payment_svg__icon card-payment_svg__icon--card-payment",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1v, _ref2$U, _ref3$s, _ref4$b, _ref5$3, _ref6)
  );
}

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1u =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.75 13.5a.75.75 0 01.75.75v9a.75.75 0 01-1.5 0v-9a.75.75 0 01.75-.75z",
  fill: "currentColor"
});

var _ref2$T =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 15.75A.75.75 0 01.75 15H7.5a3.751 3.751 0 013.675 3h3.075A3.75 3.75 0 0118 21.75a.75.75 0 01-.75.75H.75a.75.75 0 010-1.5h15.622a2.251 2.251 0 00-2.122-1.5H10.5a.75.75 0 01-.75-.75A2.25 2.25 0 007.5 16.5H.75a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

var _ref3$r =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 18.75a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H6.75a.75.75 0 01-.75-.75zM12.672.958C13.882.353 15.502 0 17.25 0c1.748 0 3.368.353 4.578.958C22.994 1.54 24 2.484 24 3.75c0 1.266-1.006 2.21-2.172 2.792-1.21.605-2.83.958-4.578.958-1.748 0-3.368-.353-4.578-.958C11.506 5.96 10.5 5.016 10.5 3.75c0-1.266 1.006-2.21 2.172-2.792zm.67 1.342C12.338 2.803 12 3.359 12 3.75s.337.947 1.343 1.45c.961.481 2.341.8 3.907.8 1.566 0 2.946-.319 3.907-.8 1.006-.503 1.343-1.059 1.343-1.45s-.337-.947-1.343-1.45c-.961-.481-2.341-.8-3.907-.8-1.566 0-2.946.319-3.907.8z",
  fill: "currentColor"
});

var _ref4$a =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 3a.75.75 0 01.75.75v7.5c0 .391.337.948 1.343 1.45.96.481 2.341.8 3.907.8 1.566 0 2.946-.319 3.907-.8 1.006-.502 1.343-1.059 1.343-1.45v-7.5a.75.75 0 011.5 0v7.5c0 1.266-1.006 2.21-2.172 2.792-1.21.605-2.83.958-4.578.958-1.748 0-3.368-.353-4.578-.958-1.166-.583-2.172-1.526-2.172-2.792v-7.5a.75.75 0 01.75-.75z",
  fill: "currentColor"
});

var _ref5$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 6.75a.75.75 0 01.75.75c0 .391.337.948 1.343 1.45.96.481 2.341.8 3.907.8 1.566 0 2.946-.319 3.907-.8C22.163 8.449 22.5 7.892 22.5 7.5a.75.75 0 011.5 0c0 1.266-1.006 2.21-2.172 2.792-1.21.605-2.83.958-4.578.958-1.748 0-3.368-.353-4.578-.958C11.506 9.71 10.5 8.766 10.5 7.5a.75.75 0 01.75-.75z",
  fill: "currentColor"
});

function SvgCashPayment(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1u({
      className: "cash-payment_svg__icon cash-payment_svg__icon--cash-payment",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1u, _ref2$T, _ref3$r, _ref4$a, _ref5$2)
  );
}

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1t =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M.75 5.25a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v13.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$S =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M.75 8.25h22.5M5.25 12.75h8.25M5.25 15.75h5.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCreditCard(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1t({
      className: "credit-card_svg__icon credit-card_svg__icon--credit-card",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1t, _ref2$S)
  );
}

function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1s =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.7 15.9c-.1 0-.2 0-.3-.1L.5 14.3c-.4-.2-.5-.6-.3-1s.6-.5 1-.3L4 14.5c.4.2.5.6.3 1-.1.3-.3.4-.6.4zM3.7 11.9c-.1 0-.2 0-.4-.1L.5 10.4c-.4-.2-.5-.7-.3-1.1.2-.3.6-.5 1-.3L4 10.5c.4.2.5.7.3 1-.1.3-.4.4-.6.4zM3.7 8.2c-.1 0-.3 0-.4-.1L1.6 7c-.3-.2-.4-.7-.2-1 .2-.4.7-.5 1-.2l1.7 1c.4.2.5.7.2 1-.1.2-.3.4-.6.4zM19.1 10.6c-.1 0-.2 0-.3-.1l-8.2-4.2c-.4-.2-.5-.6-.3-1s.6-.5 1-.3l8.2 4.2c.4.2.5.6.3 1-.2.2-.4.4-.7.4z",
  fill: "currentColor"
});

var _ref2$R =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21.9c-.4 0-.9-.1-1.3-.3l-6.2-3.2C6.6 18 6 17 6 15.9V9c0-1.1.6-2 1.5-2.5l6.2-3.2c.8-.4 1.7-.4 2.5 0l6.2 3.2C23.4 7 24 7.9 24 9v6.9c0 1.1-.6 2.1-1.5 2.6l-6.2 3.2c-.5.1-.9.2-1.3.2zm0-17.4c-.2 0-.4 0-.6.1L8.2 7.8c-.5.2-.7.7-.7 1.2v6.9c0 .5.3 1 .7 1.2l6.2 3.2c.4.2.8.2 1.2 0l6.2-3.2c.5-.2.7-.7.7-1.2V9c0-.5-.3-1-.7-1.2l-6.2-3.2c-.2-.1-.4-.1-.6-.1z",
  fill: "currentColor"
});

var _ref3$q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 12.7c-.1 0-.2 0-.3-.1l-7.9-4c-.4-.2-.5-.6-.3-1 .1-.4.5-.6.9-.4l7.6 3.9 7.6-3.9c.4-.2.8 0 1 .3.2.4 0 .8-.3 1l-7.9 4c-.2.2-.3.2-.4.2z",
  fill: "currentColor"
});

var _ref4$9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 21.9c-.4 0-.8-.3-.8-.8v-9.2c0-.4.3-.8.8-.8s.8.3.8.8v9.2c-.1.5-.4.8-.8.8zM19.1 13.5c-.4 0-.8-.3-.8-.8V9.8c0-.4.3-.8.8-.8s.8.3.8.8v2.9c-.1.4-.4.8-.8.8z",
  fill: "currentColor"
});

function SvgDelivery(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1s({
      className: "delivery_svg__icon delivery_svg__icon--delivery",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1s, _ref2$R, _ref3$q, _ref4$9)
  );
}

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1r =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zM12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5z",
  fill: "currentColor"
});

var _ref2$Q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.28 7.72a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06l7.5-7.5a.75.75 0 011.06 0zM6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM9 8.25a.75.75 0 100 1.5.75.75 0 000-1.5zM12.75 15a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25-.75a.75.75 0 100 1.5.75.75 0 000-1.5z",
  fill: "currentColor"
});

function SvgDiscount(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1r({
      className: "discount_svg__icon discount_svg__icon--discount",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1r, _ref2$Q)
  );
}

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M22.125 12a3.491 3.491 0 00-2.356-3.338 3.6 3.6 0 00-.61-4.087 3.286 3.286 0 00-3.941-.632 3.341 3.341 0 00-6.436 0 3.288 3.288 0 00-3.942.632 3.6 3.6 0 00-.609 4.087 3.542 3.542 0 000 6.675 3.6 3.6 0 00.609 4.087 3.288 3.288 0 003.942.633 3.34 3.34 0 006.436 0 3.286 3.286 0 003.941-.633 3.6 3.6 0 00.61-4.087A3.49 3.49 0 0022.125 12z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$P =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.625 15.75l7.5-7.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$p =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.375 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15.375 16.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDiscountBubble(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1q({
      className: "discount-bubble_svg__icon discount-bubble_svg__icon--discount-bubble",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1q, _ref2$P, _ref3$p)
  );
}

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1p =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.25 1.5a.75.75 0 00-.75.75V4.5a.75.75 0 01-1.5 0V2.25A2.25 2.25 0 012.25 0H4.5a.75.75 0 110 1.5H2.25z",
  fill: "currentColor"
});

var _ref2$O =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 9.375a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25zM10.875 12a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z",
  fill: "currentColor"
});

var _ref3$o =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.12 11.577l.004.007a.751.751 0 010 .832l-.005.007-.009.013-.03.045-.114.158a13.822 13.822 0 01-2.04 2.18c-1.38 1.182-3.422 2.431-5.926 2.431s-4.547-1.249-5.926-2.43a13.574 13.574 0 01-2.04-2.181l-.114-.158-.03-.045-.01-.013-.004-.007a.75.75 0 010-.832l.005-.007.009-.013.03-.045.114-.158a13.943 13.943 0 011.086-1.278l.173-.176.144-.144a14.809 14.809 0 01.637-.582C7.454 7.999 9.496 6.75 12 6.75s4.547 1.249 5.926 2.43a13.4 13.4 0 011.611 1.637c.187.223.33.41.429.544l.114.158.03.045.01.013zm-14.66.456L5.434 12l.026-.033.155-.19c.332-.398.819-.928 1.436-1.458C8.297 9.251 10.004 8.25 12 8.25s3.703 1.001 4.95 2.07c.616.529 1.103 1.06 1.435 1.457l.155.19.026.033-.026.033-.155.19c-.332.398-.819.928-1.436 1.458-1.246 1.068-2.953 2.069-4.949 2.069s-3.703-1.001-4.95-2.07a12.448 12.448 0 01-1.435-1.457l-.155-.19z",
  fill: "currentColor"
});

var _ref4$8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.784.525a.744.744 0 00.102.656.75.75 0 00.614.319h2.25a.75.75 0 01.75.75V4.5a.75.75 0 001.5 0V2.25A2.25 2.25 0 0021.75 0H19.5a.747.747 0 00-.716.525zM.75 18.75a.75.75 0 01.75.75v2.25c0 .414.336.75.75.75H4.5a.75.75 0 010 1.5H2.25A2.25 2.25 0 010 21.75V19.5a.75.75 0 01.75-.75zM24 19.5a.75.75 0 00-1.5 0v2.25a.75.75 0 01-.75.75H19.5a.75.75 0 000 1.5h2.25A2.25 2.25 0 0024 21.75V19.5z",
  fill: "currentColor"
});

function SvgEyeTest(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1p({
      className: "eye-test_svg__icon eye-test_svg__icon--eye-test",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1p, _ref2$O, _ref3$o, _ref4$8)
  );
}

function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1o =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.5c4.344-.066 8.699 2.934 11.379 5.88l.002.003a2.413 2.413 0 010 3.23l-.002.002C20.76 16.497 16.416 19.566 12 19.498c-4.416.068-8.76-3-11.376-5.883l-.002-.002a2.413 2.413 0 010-3.23l.002-.002C3.3 7.434 7.656 4.434 12 4.5zM1.735 11.389a.913.913 0 000 1.22c2.509 2.763 6.474 5.454 10.252 5.39h.026c3.778.064 7.744-2.627 10.255-5.39a.913.913 0 000-1.22c-2.566-2.82-6.543-5.45-10.255-5.387h-.026c-3.712-.063-7.69 2.567-10.252 5.387z",
  fill: "currentColor"
});

var _ref2$N =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.149 9.227a3 3 0 10-2.296 5.542 3 3 0 002.296-5.542zM12 7.5A4.499 4.499 0 0116.5 12M12 7.5A4.5 4.5 0 1016.5 12",
  fill: "currentColor"
});

function SvgEyeTestAlt(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1o({
      className: "eye-test-alt_svg__icon eye-test-alt_svg__icon--eye-test-alt",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1o, _ref2$N)
  );
}

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1n =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 22.275c-.2 0-.4-.1-.5-.2l-9.584-10c-1.997-2-2.496-5-1.198-7.5.898-1.8 2.696-3.1 4.692-3.5 1.997-.3 4.094.3 5.592 1.8l.998 1 .998-1c1.498-1.5 3.495-2.1 5.592-1.8 1.996.3 3.794 1.6 4.692 3.5 1.298 2.5.799 5.5-1.198 7.5l-9.585 10c-.1.1-.3.2-.499.2zm-5.591-19.7c-.3 0-.5 0-.799.1-1.498.2-2.895 1.2-3.594 2.6-.999 1.9-.6 4.2.898 5.7l9.086 9.4 8.986-9.4c1.497-1.5 1.897-3.8.898-5.7-.698-1.4-2.096-2.4-3.594-2.7-1.597-.3-3.195.3-4.293 1.4l-1.598 1.6c-.3.3-.798.3-1.098 0l-1.398-1.6c-.898-.9-2.196-1.4-3.494-1.4z",
  fill: "currentColor"
});

function SvgFavouriteEmpty(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1n({
      className: "favourite-empty_svg__icon favourite-empty_svg__icon--favourite-empty",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1n)
  );
}

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1m =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.5 22.075c.1.1.3.2.5.2s.4-.1.5-.2l9.584-10c1.997-2 2.496-5 1.198-7.5a6.254 6.254 0 00-4.692-3.5c-2.097-.3-4.094.3-5.592 1.8l-.998 1-.998-1c-1.498-1.5-3.595-2.1-5.592-1.8-1.996.4-3.794 1.7-4.692 3.5-1.298 2.5-.799 5.5 1.198 7.5l9.585 10z",
  fill: "currentColor"
});

function SvgFavouriteFilled(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1m({
      className: "favourite-filled_svg__icon favourite-filled_svg__icon--favourite-filled",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1m)
  );
}

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1l =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 11.25a.75.75 0 100 1.5.75.75 0 000-1.5zM9.75 12a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
  fill: "currentColor"
});

var _ref2$M =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.75c2.205-.037 4.394.798 6.338 2.016 1.953 1.224 3.71 2.866 5.065 4.522l.01.011a2.75 2.75 0 010 3.4l-.01.012c-1.325 1.62-3.064 3.263-5.016 4.497-1.942 1.227-4.146 2.08-6.387 2.042-2.241.037-4.445-.816-6.388-2.044-1.951-1.234-3.69-2.877-5.014-4.499l-.009-.01a2.75 2.75 0 010-3.4l.01-.012c1.354-1.655 3.11-3.296 5.064-4.52C7.606 4.547 9.795 3.713 12 3.75zM1.765 11.229a1.25 1.25 0 000 1.536c1.238 1.515 2.858 3.04 4.649 4.173 1.798 1.137 3.718 1.846 5.572 1.812h.028c1.854.035 3.774-.674 5.572-1.81 1.791-1.132 3.411-2.657 4.651-4.173a1.25 1.25 0 000-1.535c-1.267-1.548-2.903-3.071-4.696-4.195-1.8-1.128-3.706-1.82-5.527-1.787h-.028c-1.82-.034-3.727.659-5.527 1.786C4.667 8.16 3.031 9.682 1.765 11.23z",
  fill: "currentColor"
});

var _ref3$n =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM6 12a6 6 0 1112 0 6 6 0 01-12 0z",
  fill: "currentColor"
});

var _ref4$7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.75a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V4.5a.75.75 0 01.75-.75zM12 15a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0v-3.75A.75.75 0 0112 15zM15 12a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3A.75.75 0 0115 12zM4.5 12a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3A.75.75 0 014.5 12z",
  fill: "currentColor"
});

function SvgIrisScan(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1l({
      className: "iris-scan_svg__icon iris-scan_svg__icon--iris-scan",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1l, _ref2$M, _ref3$n, _ref4$7)
  );
}

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1k =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.078 8.286c.063.09.057.21-.015.292a5.589 5.589 0 00-.093 7.299c.069.082.073.2.01.288a.242.242 0 01-.278.085 5.314 5.314 0 00-3.544-.033.242.242 0 01-.275-.089.235.235 0 01.011-.286 5.6 5.6 0 000-7.197.235.235 0 01-.011-.287.242.242 0 01.275-.088 5.326 5.326 0 003.637-.068.242.242 0 01.283.084zm-.846.587a5.766 5.766 0 01-2.548.033 6.05 6.05 0 011 3.337c0 1.23-.369 2.376-1.001 3.337a5.787 5.787 0 012.488.02 6.049 6.049 0 01-.99-3.322m1.05-3.405a6.033 6.033 0 00-1.05 3.405z",
  fill: "currentColor"
});

var _ref2$L =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.72 16.96c2.651 0 4.8-2.123 4.8-4.743s-2.149-4.743-4.8-4.743-4.8 2.124-4.8 4.743c0 2.62 2.149 4.743 4.8 4.743zm-13.44 0c2.651 0 4.8-2.123 4.8-4.743s-2.149-4.743-4.8-4.743-4.8 2.124-4.8 4.743c0 2.62 2.149 4.743 4.8 4.743zm0 .475c2.916 0 5.28-2.336 5.28-5.218C10.56 9.336 8.196 7 5.28 7 2.364 7 0 9.336 0 12.217c0 2.882 2.364 5.218 5.28 5.218zm13.44 0c2.916 0 5.28-2.336 5.28-5.218C24 9.336 21.636 7 18.72 7c-2.916 0-5.28 2.336-5.28 5.217 0 2.882 2.364 5.218 5.28 5.218z",
  fill: "currentColor"
});

var _ref3$m =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.574 14c.126 0 .192-.048.192-.156v-.528c0-.144-.06-.186-.192-.186h-1.56V9.956c0-.114-.042-.192-.174-.192h-.654c-.12 0-.186.078-.186.198v3.846c0 .144.096.192.186.192h2.388z",
  fill: "currentColor"
});

function SvgLeftEye(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1k({
      className: "left-eye_svg__icon left-eye_svg__icon--left-eye",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1k, _ref2$L, _ref3$m)
  );
}

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1j =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 7.499a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h3a.75.75 0 010 1.5h-3A2.25 2.25 0 010 15.749v-7.5a2.25 2.25 0 012.25-2.25h19.5A2.25 2.25 0 0124 8.249v7.5a2.25 2.25 0 01-2.25 2.25h-3a.75.75 0 010-1.5h3a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25z",
  fill: "currentColor"
});

var _ref2$K =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 9.749a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM4.5 12.749a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v10.5a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75v-10.5zm1.5.75v9h12v-9H6zM6.75 1.499a.75.75 0 00-.75.75v3.75h12v-3.75a.75.75 0 00-.75-.75H6.75zm-2.25.75a2.25 2.25 0 012.25-2.25h10.5a2.25 2.25 0 012.25 2.25v4.5a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75v-4.5z",
  fill: "currentColor"
});

var _ref3$l =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 15.749a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM7.5 18.749a.75.75 0 01.75-.75h5.25a.75.75 0 010 1.5H8.25a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgPrinter(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1j({
      className: "printer_svg__icon printer_svg__icon--printer",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1j, _ref2$K, _ref3$l)
  );
}

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1i =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.78.22a.75.75 0 010 1.06L6.56 4.5H17.94l-3.22-3.218A.75.75 0 1115.78.222L20.06 4.5h1.291a2.237 2.237 0 012.084 2.796l-.298 1.248a.75.75 0 01-1.46-.348l.3-1.256.005-.018A.732.732 0 0021.309 6H3.19a.733.733 0 00-.673.921l.005.02 2.137 9 .004.014c.068.312.34.537.658.545h3.553a.75.75 0 010 1.5H5.3a2.192 2.192 0 01-2.1-1.72L1.064 7.297A2.234 2.234 0 013.15 4.5h1.29L8.72.22a.75.75 0 011.06 0zm8.654 11.79a4.822 4.822 0 00-4.891 3.25.75.75 0 11-1.419-.486 6.32 6.32 0 0111.376-1.25V12a.75.75 0 011.5 0v3.75a.75.75 0 01-.75.75H20.5a.75.75 0 010-1.5h2.07a4.822 4.822 0 00-4.136-2.99zM13 22.5v-1.524a6.324 6.324 0 0011.377-1.25.75.75 0 00-1.42-.486 4.822 4.822 0 01-9.027.26H16a.75.75 0 000-1.5h-3.75a.75.75 0 00-.75.75v3.75a.75.75 0 001.5 0z",
  fill: "currentColor"
});

function SvgReturns(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1i({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1i)
  );
}

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1h =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.8 15c-.5 0-.8-.3-.8-.7V12c0-1.9.6-3.7 1.6-5.2S7.2 4.2 9 3.5c1.8-.6 3.6-.7 5.4-.2 1.8.5 3.4 1.5 4.6 2.9.3.3.2.8-.1 1.1-.3.3-.8.2-1.1-.1-1-1.2-2.3-2-3.8-2.5-1.5-.4-3.1-.4-4.5.2-1.5.6-2.7 1.5-3.6 2.8C5 9 4.5 10.4 4.5 12v2.3c0 .4-.3.7-.7.7zM12 21c-.7 0-1.3-.1-2-.2-1.8-.4-3.4-1.3-4.6-2.6-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0 1 1.1 2.4 1.8 3.8 2.2 1.5.3 3 .2 4.4-.4 1.4-.6 2.6-1.5 3.4-2.8.8-1.2 1.3-2.7 1.3-4.2v-1.4c0-.4.3-.8.8-.8s.8.4.8.8V12c0 1.8-.5 3.6-1.6 5.1-1 1.5-2.4 2.6-4.1 3.3-1 .4-2.2.6-3.3.6z",
  fill: "currentColor"
});

var _ref2$J =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.8 15c-.2 0-.4-.1-.5-.2l-3-3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.5 2.5 2.5-2.5c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-3 3c-.4.1-.6.2-.7.2zM23.2 14.2c-.2 0-.4-.1-.5-.2l-2.5-2.5-2.4 2.5c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l3-3c.3-.3.8-.3 1.1 0l3 3c.3.3.3.8 0 1.1-.2.2-.4.2-.6.2z",
  fill: "currentColor"
});

function SvgReturnsAlt(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1h({
      className: "returns-alt_svg__icon returns-alt_svg__icon--returns-alt",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1h, _ref2$J)
  );
}

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1g =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.078 8.286c.063.09.057.21-.015.292a5.589 5.589 0 00-.093 7.299c.069.082.073.2.01.288a.242.242 0 01-.278.085 5.314 5.314 0 00-3.544-.033.242.242 0 01-.275-.089.235.235 0 01.011-.286 5.6 5.6 0 000-7.197.235.235 0 01-.011-.287.242.242 0 01.275-.088 5.326 5.326 0 003.637-.068.242.242 0 01.283.084zm-.846.587a5.766 5.766 0 01-2.548.033 6.05 6.05 0 011 3.337c0 1.23-.369 2.376-1.001 3.337a5.787 5.787 0 012.488.02 6.049 6.049 0 01-.99-3.322m1.05-3.405a6.033 6.033 0 00-1.05 3.405z",
  fill: "currentColor"
});

var _ref2$I =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.72 16.96c2.651 0 4.8-2.123 4.8-4.743s-2.149-4.743-4.8-4.743-4.8 2.124-4.8 4.743c0 2.62 2.149 4.743 4.8 4.743zm-13.44 0c2.651 0 4.8-2.123 4.8-4.743s-2.149-4.743-4.8-4.743-4.8 2.124-4.8 4.743c0 2.62 2.149 4.743 4.8 4.743zm0 .475c2.916 0 5.28-2.336 5.28-5.218C10.56 9.336 8.196 7 5.28 7 2.364 7 0 9.336 0 12.217c0 2.882 2.364 5.218 5.28 5.218zm13.44 0c2.916 0 5.28-2.336 5.28-5.218C24 9.336 21.636 7 18.72 7c-2.916 0-5.28 2.336-5.28 5.217 0 2.882 2.364 5.218 5.28 5.218z",
  fill: "currentColor"
});

var _ref3$k =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.314 13.938V12.51h.486l.72 1.488c.042.078.102.138.228.138h.714c.078 0 .15-.054.15-.138a.486.486 0 00-.072-.222l-.792-1.452c.486-.228.618-.666.618-1.146 0-.522-.15-.936-.606-1.122-.228-.096-.636-.156-1.278-.156h-.96c-.192 0-.222.096-.222.21v3.828c0 .138.078.198.18.198h.636c.108 0 .198-.066.198-.198zm0-2.214v-.996h.258c.216 0 .402.012.51.048.174.06.246.198.246.462 0 .222-.084.372-.258.432-.126.042-.288.054-.498.054h-.258z",
  fill: "currentColor"
});

function SvgRightEye(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1g({
      className: "right-eye_svg__icon right-eye_svg__icon--right-eye",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1g, _ref2$I, _ref3$k)
  );
}

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1f =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.746 3.18a.75.75 0 01.081 1.058L6.388 8.25h11.74l-3.44-4.012a.75.75 0 111.14-.976l4.275 4.988h1.254a2.234 2.234 0 012.084 2.796l-2.134 8.985a2.192 2.192 0 01-2.1 1.719H5.306a2.192 2.192 0 01-2.1-1.72l-2.135-8.984a2.234 2.234 0 012.11-2.796h1.23l4.276-4.988a.75.75 0 011.058-.081zM4.753 9.75H3.198a.734.734 0 00-.673.921l.004.02 2.138 9 .004.014c.067.312.34.537.658.545h13.856a.692.692 0 00.658-.545l.003-.014 2.138-9 .005-.02a.734.734 0 00-.674-.921h-1.552a.69.69 0 01-.01 0H4.753zm3.005 1.5a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75zm4.5 0a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75zm4.5 0a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75z",
  fill: "currentColor"
});

function SvgShoppingBag(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1f({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1f)
  );
}

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1e =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M20.6 10.5c-.9 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-1.7 0-3-1.3-3-3v-.2l1.4-6.2C1.5.5 1.7 0 2.5 0h18.3c.7 0 1.3.5 1.5 1.2l1.3 6.1v.2c0 1.7-1.3 3-3 3zm-2.2-3.7c.4 0 .8.3.8.8-.1.7.6 1.4 1.4 1.4.8 0 1.5-.6 1.5-1.4l-1.4-6.1H2.5L1.1 7.6c0 .8.7 1.4 1.5 1.4s1.5-.7 1.5-1.5c0-.4.3-.8.8-.8s.7.4.7.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-.4.3-.8.8-.8s.8.3.8.8c-.1.8.6 1.5 1.4 1.5.8 0 1.5-.7 1.5-1.5 0-.4.3-.8.8-.8s.7.4.7.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-.4.3-.7.8-.7zM3.4 24c-1.2 0-2.2-1-2.2-2.2v-9c0-.4.3-.8.8-.8s.6.3.6.8v9c0 .4.3.8.8.8h8.2v-6.2c0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8v6.2h.7c.4 0 .8-.3.8-.8v-9c0-.4.3-.8.8-.8s.8.3.8.8v9c-.2 1.2-1.2 2.2-2.5 2.2H3.4zm14.2-7.5v6h-4.4v-6c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2zm-9 4.5h-3c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h3c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5zm-3-4.5v3h3v-3h-3zm9 1.9c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1z"
});

function SvgStore(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1e({
      className: "store_svg__icon store_svg__icon--store",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1e)
  );
}

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1d =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 6a2.25 2.25 0 012.25-2.25h12A2.25 2.25 0 0124 6v7.5a.75.75 0 01-1.5 0V6a.75.75 0 00-.75-.75h-12A.75.75 0 009 6v6a.75.75 0 01-1.5 0V6z",
  fill: "currentColor"
});

var _ref2$H =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10.5c0-2.9 2.35-5.25 5.25-5.25h3A.75.75 0 019 6v6a.75.75 0 01-1.5 0V6.75H5.25A3.75 3.75 0 001.5 10.5v6c0 .414.336.75.75.75H3a.75.75 0 010 1.5h-.75A2.25 2.25 0 010 16.5v-6z",
  fill: "currentColor"
});

var _ref3$j =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 5.25A.75.75 0 016 6v4.5a2.25 2.25 0 01-2.25 2.25h-3a.75.75 0 010-1.5h3a.75.75 0 00.75-.75V6a.75.75 0 01.75-.75zM4.5 17.25a3 3 0 116 0 3 3 0 01-6 0zm3-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM16.5 17.25a3 3 0 116 0 3 3 0 01-6 0zm3-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11.25 18a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgTruck(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1d({
      className: "truck_svg__icon truck_svg__icon--truck",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1d, _ref2$H, _ref3$j)
  );
}

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1c =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.25 3.923H3v-.005l-.75.005zm0 7.614H1.5h.75zM9.882 22.65l-.27.7h.001l.269-.7zm1.041.4l.27-.7h-.001l-.269.7zm2.154 0l-.269-.7.269.7zm1.041-.4l.269.7-.269-.7zm7.632-11.113h.75-.75zm0-7.614L21 3.918v.005h.75zm-.868-1.362l.312-.682-.012-.005-.3.687zM12 .75l-.007.75h.014L12 .75zM3.118 2.561l-.3-.688-.012.006.312.682zM9.75 9.75a.75.75 0 000 1.5v-1.5zm4.5 1.5a.75.75 0 000-1.5v1.5zm-1.5-3a.75.75 0 00-1.5 0h1.5zm-1.5 4.5a.75.75 0 001.5 0h-1.5zM1.5 3.923v7.614H3V3.923H1.5zm0 7.614c0 5.237 3.225 9.933 8.113 11.813l.538-1.4A11.157 11.157 0 013 11.537H1.5zM9.613 23.35l1.041.4.538-1.4-1.041-.4-.538 1.4zm1.04.4a3.75 3.75 0 002.693 0l-.538-1.4c-.52.2-1.096.2-1.616 0l-.538 1.4zm2.693 0l1.041-.4-.538-1.4-1.041.4.538 1.4zm1.041-.4A12.657 12.657 0 0022.5 11.537H21c0 4.616-2.843 8.756-7.151 10.413l.538 1.4zM22.5 11.537V3.923H21v7.614h1.5zm0-7.609a2.237 2.237 0 00-1.306-2.049l-.624 1.364c.264.12.432.385.43.675l1.5.01zm-1.318-2.054A22.45 22.45 0 0011.993 0l.014 1.5a20.95 20.95 0 018.575 1.748l.6-1.374zM12.007 0a22.45 22.45 0 00-9.189 1.874l.6 1.374A20.95 20.95 0 0111.993 1.5l.014-1.5zM2.806 1.879A2.237 2.237 0 001.5 3.928l1.5-.01a.737.737 0 01.43-.675l-.624-1.364zM8.25 6h7.5V4.5h-7.5V6zm8.25.75v7.5H18v-7.5h-1.5zM15.75 15h-7.5v1.5h7.5V15zm-8.25-.75v-7.5H6v7.5h1.5zm.75.75a.75.75 0 01-.75-.75H6a2.25 2.25 0 002.25 2.25V15zm8.25-.75a.75.75 0 01-.75.75v1.5A2.25 2.25 0 0018 14.25h-1.5zM15.75 6a.75.75 0 01.75.75H18a2.25 2.25 0 00-2.25-2.25V6zm-7.5-1.5A2.25 2.25 0 006 6.75h1.5A.75.75 0 018.25 6V4.5zm1.5 6.75h4.5v-1.5h-4.5v1.5zm1.5-3v4.5h1.5v-4.5h-1.5z",
  fill: "currentcolor"
});

function SvgWarranty(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1c({
      className: "warranty_svg__icon warranty_svg__icon--credit-card",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1c)
  );
}

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1b =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 23.25H3.25A2.25 2.25 0 011 21",
  stroke: "#2B2E31",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$G =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M4 .75a3 3 0 00-3 3V21a2.25 2.25 0 012.25-2.25h15A.75.75 0 0019 18V1.5a.75.75 0 00-.75-.75H4z",
  stroke: "#2B2E31",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$i =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.5 23.25v-4.5",
  stroke: "#2B2E31",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4$6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.5 15.75a4.5 4.5 0 119 0h-9z",
  stroke: "#2B2E31",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M10 11.25a3 3 0 100-6 3 3 0 000 6z",
  stroke: "#2B2E31",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAddressBook(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1b({
      width: 20,
      height: 24,
      fill: "none"
    }, props), _ref$1b, _ref2$G, _ref3$i, _ref4$6, _ref5$1)
  );
}

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$1a =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.547 2a.75.75 0 01.75.75v1.648h6.902V2.75a.75.75 0 011.5 0v1.648h2.551a2.25 2.25 0 012.25 2.25v12.6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012 19.248v-12.6a2.25 2.25 0 012.25-2.25h2.547V2.75a.75.75 0 01.75-.75zm-.75 3.898H4.25a.75.75 0 00-.75.75V9.2H20V6.65a.75.75 0 00-.75-.75H16.7V6.95a.75.75 0 01-1.5 0V5.898H8.296V6.95a.75.75 0 01-1.5 0V5.898zM20 10.7H3.5v8.55c0 .414.336.75.75.75h15a.75.75 0 00.75-.75v-8.55zM5.598 13.25a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0zm5.101 0a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0zm5.098 0a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0zm-10.2 4.2a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0zm5.102 0a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0zm5.098 0a1.05 1.05 0 112.1 0 1.05 1.05 0 01-2.1 0z",
  fill: "currentColor"
});

function SvgCalendar(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1a({
      className: "calendar_svg__icon calendar_svg__icon--calendar",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1a)
  );
}

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.47a5.98 5.98 0 00-5.98 5.98c0 .642.256 1.61.727 2.81.463 1.174 1.1 2.49 1.79 3.793 1.26 2.38 2.674 4.675 3.462 5.92.79-1.245 2.203-3.54 3.463-5.92.69-1.304 1.327-2.62 1.79-3.795.472-1.198.728-2.167.728-2.807A5.982 5.982 0 0012 1.469zm-5.269.712A7.45 7.45 0 0119.45 7.451c0 .935-.348 2.123-.83 3.346-.49 1.246-1.155 2.615-1.858 3.943-1.407 2.657-2.995 5.2-3.73 6.348a1.225 1.225 0 01-2.063 0c-.735-1.148-2.323-3.69-3.73-6.347-.703-1.328-1.367-2.697-1.858-3.944-.482-1.223-.83-2.41-.83-3.346M6.73 2.182a7.45 7.45 0 00-2.181 5.27zm1.106 4.92a4.163 4.163 0 118.326 0 4.163 4.163 0 01-8.326 0zM12 4.408a2.694 2.694 0 100 5.388 2.694 2.694 0 000-5.388zm4.166 15.073a.735.735 0 01.794-.67c1.905.16 3.546.412 4.728.733.585.159 1.099.345 1.483.57.328.191.829.568.829 1.192 0 .443-.26.76-.488.955-.233.198-.535.357-.852.487-.643.265-1.528.487-2.568.667C18 23.78 15.14 24 12 24c-3.14 0-6-.22-8.092-.585-1.04-.18-1.925-.402-2.568-.667-.318-.13-.619-.289-.852-.487C.26 22.067 0 21.749 0 21.306c0-.622.498-.999.824-1.19.383-.225.895-.412 1.476-.57 1.174-.321 2.805-.573 4.698-.735a.735.735 0 11.126 1.464c-1.852.158-3.384.4-4.437.688-.43.117-.751.235-.974.343.054.026.116.054.186.083.498.205 1.262.405 2.26.579 1.986.345 4.759.563 7.841.563s5.855-.218 7.84-.563c.999-.174 1.763-.374 2.26-.579.07-.029.133-.056.186-.082a5.852 5.852 0 00-.983-.345c-1.06-.288-2.603-.53-4.467-.687a.735.735 0 01-.67-.794zm6.42 2.014l-.008-.009.008.01zm-21.164-.01l-.008.01.008-.01z",
  fill: "currentColor"
});

function SvgLocation(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$19({
      className: "location_svg__icon location_svg__icon--location",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$19)
  );
}

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 8.233A2.25 2.25 0 016.75 6h10.5a2.25 2.25 0 012.25 2.264v7.486A2.25 2.25 0 0117.25 18H6.75a2.25 2.25 0 01-2.25-2.25V8.263v-.03zM6 9.525v6.225c0 .414.336.75.75.75h10.5a.75.75 0 00.75-.75V9.525l-5.636 3.13a.75.75 0 01-.728 0L6 9.526zm11.895-1.658L12 11.142 6.105 7.867A.75.75 0 016.75 7.5h10.5a.75.75 0 01.645.367z",
  fill: "currentColor"
});

var _ref2$F =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zM12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5z",
  fill: "currentColor"
});

function SvgMail(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$18({
      className: "mail_svg__icon mail_svg__icon--mail",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$18, _ref2$F)
  );
}

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.332 14.768c1.3 5.4 6.1 9.2 11.7 9.2 2.7 0 4.7-.7 5.8-2.3.44-.703.879-1.869.437-3.497.16-.121.315-.255.463-.403l.5-.5c.7-.7.7-1.9 0-2.6l-1.9-1.9c-.7-.7-1.9-.7-2.6 0-.2.1-.4.1-.5 0l-3-3c-.1-.2-.1-.4 0-.5.7-.7.7-1.9 0-2.6l-1.9-1.9c-.7-.7-1.9-.7-2.6 0l-.5.5c-1.3 1.3-1.6 3.3-.6 4.9.1 0 .1.1.1.1 2.1 3.2 4.8 5.9 8 8 0 .1.1.1.1.1.7.4 1.4.6 2.1.6.309 0 .618-.038.92-.115.15.785.058 1.486-.32 2.015-.6 1-2.2 1.5-4.4 1.5-4.9 0-9.1-3.3-10.2-8.1-1.1-4.8 1.1-9.6 5.5-11.8 4.4-2.2 9.7-1.1 12.8 2.7 3.1 3.7 3.2 9.1.3 13-.3.4-.2.9.1 1.1.3.3.8.2 1-.1 3.3-4.5 3.2-10.6-.4-14.9-3.6-4.2-9.6-5.5-14.6-3s-7.6 8-6.3 13.5zm16.816 2.276a1.238 1.238 0 00-.116.024.838.838 0 00-.197.134 2.378 2.378 0 01-2.303-.234c-3-2-5.5-4.5-7.5-7.5-.7-1-.5-2.3.3-3.1l.4-.5c.2-.1.4-.1.5 0l1.9 1.8c.1.2.1.4 0 .5-.7.7-.7 1.9 0 2.6l3 3c.7.7 1.9.7 2.6 0 .2-.1.4-.1.5 0l1.9 1.9c.1.2.1.4 0 .5l-.5.5c-.146.146-.309.272-.484.376z",
  fill: "currentColor"
});

function SvgPhone(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$17({
      className: "phone_svg__icon phone_svg__icon--phone",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$17)
  );
}

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.569 8.816l.12.043v.607c0 .415.29 1.757.89 2.016.598.258 2.136.43 2.833-.126a3.84 3.84 0 001.135-2.05 1.143 1.143 0 01.889 0 3.84 3.84 0 001.135 2.05c.696.556 2.234.392 2.833.126.6-.267.87-1.601.889-2.016v-.607l.117-.043a.168.168 0 00.141-.192V8.34c0-.157-.082-.188-.188-.192-.391-.024-.783-.074-1.276-.106a8.391 8.391 0 00-1.092 0 9.28 9.28 0 00-2.027.337 3.245 3.245 0 01-.756.192h-.446a3.217 3.217 0 01-.751-.192 9.32 9.32 0 00-2.032-.337 8.333 8.333 0 00-1.088 0c-.497.032-.88.082-1.276.106-.11 0-.191.035-.191.192v.285a.168.168 0 00.14.192z"
});

var _ref2$E =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z"
});

var _ref3$h =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.78 12.234l-3.424 4.411a.556.556 0 01-.732 0l-3.42-4.41a.391.391 0 10-.619.477l3.444 4.446.036.035a1.32 1.32 0 001.867 0l.03-.035 3.445-4.43a.391.391 0 00-.066-.549.391.391 0 00-.56.055zM8.032 7.227l3.6-4.63a.556.556 0 01.732 0l3.601 4.63a.391.391 0 10.619-.478l-3.62-4.657-.032-.035a1.354 1.354 0 00-1.867 0l-.035.035-3.617 4.657a.391.391 0 10.619.478z"
});

var _ref4$5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.39 15.883c0 1.424-1.957 2.575-3.358 2.575-1.402 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.317-.113c-.528-.576-1.93-1.812-4.696-2.552h-.09z"
});

function SvgDiamond(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$16({
      className: "diamond_svg__icon diamond_svg__icon--face-shape-diamond",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$16, _ref2$E, _ref3$h, _ref4$5)
  );
}

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.314 7.079a9.984 9.984 0 00-3.28.356 3.413 3.413 0 01-.782.204h-.498a3.413 3.413 0 01-.782-.204 9.976 9.976 0 00-3.28-.356c-.52.031-.924.086-1.343.11-.11 0-.2.035-.2.203v.301a.18.18 0 00.15.2l.125.043v.638c0 .435.301 1.847.931 2.121.63.274 2.247.454 2.979-.137a4.004 4.004 0 001.174-2.152 1.217 1.217 0 01.932 0c.16.821.57 1.573 1.174 2.152.735.591 2.348.392 2.978.137.63-.254.916-1.686.935-2.12v-.639l.122-.043a.176.176 0 00.149-.2v-.3c0-.17-.087-.2-.196-.204-.368-.024-.767-.079-1.288-.11zM6.913 6.416a.391.391 0 00.724-.294l-.748-1.878h9.922l-.748 1.863a.39.39 0 00.724.293l.951-2.387a.391.391 0 00-.364-.536H6.314a.391.391 0 00-.364.536l.963 2.403zM13.824 11.548l-1.957 4.38-1.957-4.297a.391.391 0 10-.712.317l2.278 5.088a.391.391 0 00.572.168.391.391 0 00.144-.168l2.313-5.178a.392.392 0 00-.716-.321l.035.011z"
});

var _ref2$D =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z"
});

var _ref3$g =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.444 15.883h-.054c0 1.424-1.957 2.575-3.358 2.575-1.402 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.317-.113c-.548-.576-1.949-1.812-4.732-2.552z"
});

function SvgHeart(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$15({
      className: "heart_svg__icon heart_svg__icon--face-shape-heart",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$15, _ref2$D, _ref3$g)
  );
}

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z"
});

var _ref2$C =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.502 8.054l.117.044v.614c0 .419.294 1.78.9 2.043.607.262 2.161.438 2.87-.13.593-.554 1-1.28 1.162-2.077.287-.119.61-.119.896 0a3.89 3.89 0 001.15 2.074c.705.568 2.263.391 2.87.13.606-.263.88-1.625.9-2.044v-.614c.031 0 .078-.024.121-.043a.168.168 0 00.141-.192v-.29c0-.16-.082-.192-.188-.196-.391-.023-.782-.074-1.295-.105a8.571 8.571 0 00-1.104 0 9.26 9.26 0 00-2.055.34c-.245.096-.501.16-.763.192h-.47a3.162 3.162 0 01-.782-.192 9.217 9.217 0 00-2.051-.34 8.571 8.571 0 00-1.104 0c-.505.031-.892.082-1.295.105-.106 0-.192.036-.192.196v.29a.172.172 0 00.172.195zM16.054 11.815c-.705 2.235-2.294 3.675-4.059 3.675-1.687 0-3.252-1.358-3.984-3.464a.391.391 0 00-.74.258c.846 2.423 2.7 3.989 4.724 3.989 2.114 0 3.996-1.656 4.807-4.223a.391.391 0 10-.748-.235zM7.36 6.592a.42.42 0 00.098 0 .391.391 0 00.391-.29c.619-2.41 2.29-4.015 4.145-4.015 1.855 0 3.523 1.62 4.16 4.027a.391.391 0 10.756-.196c-.72-2.775-2.697-4.614-4.916-4.614-2.219 0-4.192 1.84-4.912 4.599a.391.391 0 00.278.489z"
});

var _ref3$f =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.39 15.883c0 1.424-1.957 2.575-3.358 2.575-1.402 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.313-.113c-.524-.576-1.925-1.812-4.696-2.552h-.086z"
});

function SvgOval$1(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$14({
      className: "oval_svg__icon oval_svg__icon--face-shape-oval",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$14, _ref2$C, _ref3$f)
  );
}

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.492 7.969c.039.018.08.032.121.043v.618c.02.419.294 1.78.9 2.043.607.262 2.165.438 2.873-.13a3.875 3.875 0 001.151-2.077 1.174 1.174 0 01.9 0 3.914 3.914 0 001.151 2.078c.708.567 2.266.391 2.873.129.606-.262.884-1.624.9-2.043v-.618a.781.781 0 00.121-.043.168.168 0 00.141-.192v-.29c0-.16-.082-.192-.192-.196-.39-.023-.782-.074-1.291-.105a8.638 8.638 0 00-1.108 0 9.217 9.217 0 00-2.055.34 3.35 3.35 0 01-.782.196h-.47c-.268-.034-.53-.1-.783-.196a9.26 9.26 0 00-2.055-.34 8.638 8.638 0 00-1.107 0c-.501.031-.889.082-1.296.105-.105 0-.192.036-.192.196v.278a.172.172 0 00.2.204z"
});

var _ref2$B =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z"
});

var _ref3$e =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.872 11.219a.391.391 0 00-.39.391v2.572a1.296 1.296 0 001.252 1.334h6.532a1.295 1.295 0 001.244-1.334V11.61a.391.391 0 00-.782 0v2.572a.517.517 0 01-.462.551H8.734a.52.52 0 01-.466-.551V11.61a.391.391 0 00-.396-.391zM7.872 6.771a.391.391 0 00.392-.391V3.225a.524.524 0 01.47-.548h6.532a.52.52 0 01.462.552v3.23a.391.391 0 00.782 0V3.224a1.295 1.295 0 00-1.248-1.33H8.733a1.295 1.295 0 00-1.252 1.33V6.38a.391.391 0 00.391.391zM15.39 15.883c0 1.424-1.957 2.575-3.358 2.575-1.402 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.313-.113c-.524-.576-1.925-1.812-4.696-2.552h-.086z"
});

function SvgRectangular(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$13({
      className: "rectangular_svg__icon rectangular_svg__icon--face-shape-square",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$13, _ref2$B, _ref3$e)
  );
}

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.912 8.298a.924.924 0 00.133.047v.685c.024.462.325 1.957.998 2.263.673.305 2.396.481 3.178-.145a4.305 4.305 0 001.272-2.298 1.252 1.252 0 01.995 0c.176.88.622 1.683 1.275 2.298.783.626 2.505.434 3.178.145.674-.29.975-1.8.995-2.263v-.685a.927.927 0 00.133-.047.183.183 0 00.156-.21v-.322c0-.176-.09-.211-.211-.215-.446-.027-.877-.082-1.433-.117a9.588 9.588 0 00-1.22 0c-.77.047-1.533.178-2.275.39a3.73 3.73 0 01-.845.216h-.501a3.68 3.68 0 01-.845-.215 10.607 10.607 0 00-2.274-.391 9.656 9.656 0 00-1.225 0c-.556.035-.983.09-1.433.117-.117 0-.211.04-.211.215v.321a.188.188 0 00.16.211z",
  fill: "currentColor"
});

var _ref2$A =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z",
  fill: "currentColor"
});

var _ref3$d =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.924 11.635a.391.391 0 00-.517.2 5.871 5.871 0 01-10.735 0 .391.391 0 10-.713.32 6.654 6.654 0 0012.165 0 .391.391 0 00-.2-.52zM6.15 7.231c.05.02.105.03.16.032a.391.391 0 00.36-.231 5.87 5.87 0 0110.74 0 .392.392 0 10.716-.321 6.654 6.654 0 00-12.172 0 .391.391 0 00.195.52z",
  fill: "currentColor"
});

var _ref4$4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.39 15.883c0 1.424-1.934 2.575-3.358 2.575-1.425 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.313-.113c-.524-.576-1.925-1.812-4.696-2.552h-.086z",
  fill: "currentColor"
});

function SvgRound$1(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$12({
      className: "round_svg__icon round_svg__icon--face-shape-round",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$12, _ref2$A, _ref3$d, _ref4$4)
  );
}

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.852 10.895a.391.391 0 00-.391.39v2.412a1.405 1.405 0 001.401 1.401h8.278a1.4 1.4 0 001.401-1.401v-2.411a.391.391 0 10-.783 0v2.41a.618.618 0 01-.618.62H7.862a.618.618 0 01-.618-.62v-2.41a.391.391 0 00-.392-.391zM6.852 6.644a.391.391 0 00.392-.391V4.132a.618.618 0 01.618-.619h8.278a.618.618 0 01.618.619v2.121a.391.391 0 10.783 0V4.132A1.401 1.401 0 0016.14 2.73H7.862a1.401 1.401 0 00-1.401 1.402v2.121a.391.391 0 00.391.391z"
});

var _ref2$z =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996.07A12 12 0 1024 12.07a12.012 12.012 0 00-12.004-12zm0 23.214A11.217 11.217 0 1123.217 12.07a11.229 11.229 0 01-11.22 11.214z"
});

var _ref3$c =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.1 7.81l.133.047v.661c0 .446.317 1.906.966 2.188.65.282 2.321.47 3.104-.137a4.168 4.168 0 001.233-2.227 1.24 1.24 0 01.963 0 4.22 4.22 0 001.233 2.227c.759.607 2.43.419 3.08.137.65-.282.927-1.742.927-2.188v-.661l.13-.047a.18.18 0 00.152-.204v-.313c0-.172-.09-.203-.203-.207-.435-.024-.85-.082-1.39-.114a9.002 9.002 0 00-1.174 0c-.746.04-1.485.164-2.203.368-.264.1-.539.17-.818.208h-.486a3.64 3.64 0 01-.818-.208c-.715-.2-1.45-.321-2.192-.36a9.049 9.049 0 00-1.174 0c-.536.031-.95.09-1.385.114-.118 0-.204.035-.204.207v.313a.18.18 0 00.125.196zM15.39 15.883c0 1.424-1.957 2.575-3.358 2.575-1.402 0-3.359-1.15-3.359-2.575-2.994.783-4.383 2.164-4.814 2.665a10.176 10.176 0 0016.313-.113c-.524-.576-1.925-1.812-4.696-2.552h-.086z"
});

function SvgSquare$1(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$11({
      className: "square_svg__icon square_svg__icon--face-shape-square",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$11, _ref2$z, _ref3$c)
  );
}

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.011 12.011 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

var _ref2$y =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.093 12.067c-.033 1.974-2.012 3.449-3.5 3.449-1.932 0-3.5-1.5-3.5-2.5 0-2.543 1.367-2.538 3.204-2.531h.297c1.256 0 2.521.079 3.128.64.392-.096.843-.14 1.278-.14.462 0 .943.05 1.351.16.6-.58 1.878-.66 3.149-.66h.297c1.837-.007 3.203-.012 3.203 2.531 0 1-1.567 2.5-3.5 2.5-1.482 0-3.453-1.464-3.5-3.428a4.591 4.591 0 00-1-.102c-.327 0-.642.029-.907.081z",
  fill: "currentColor"
});

function SvgAlmond(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$10({
      className: "almond_svg__icon almond_svg__icon--frame-shape-almond",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$10, _ref2$y)
  );
}

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$$ =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.852 12.477c.023.165.066.392.125.611.391 1.59 1.381 2.466 2.783 2.466 1.67 0 3.522-1.268 4.266-2.947a4.19 4.19 0 00.145-.368.502.502 0 00.023-.047c.223-.474.415-.76.783-.76.235 0 .466.024.884.9.036.09.07.185.114.275.783 1.679 2.595 2.947 4.266 2.947 1.401 0 2.391-.877 2.783-2.47.055-.235.098-.438.121-.603a4.368 4.368 0 00-.176-1.59v-.018a1.84 1.84 0 00-.783-1.112 5.21 5.21 0 00-1.636-.563 7.547 7.547 0 00-1.409-.126c-.414 0-.827.031-1.237.094h-.027l-.223.043c-.16.03-.319.07-.474.122a.25.25 0 00-.07.023h-.035l-.15.055-.093.04h-3.648l-.098-.036-.176-.035h-.035l-.078-.028a4.277 4.277 0 00-.478-.121l-.23-.043a7.902 7.902 0 00-1.245-.098 7.545 7.545 0 00-1.41.125 5.21 5.21 0 00-1.612.556 1.847 1.847 0 00-.783 1.112v.02a4.371 4.371 0 00-.172 1.565l-.015.011zm9.068-2.348c-.12.154-.213.328-.274.513a1.048 1.048 0 00-.043.286 1.459 1.459 0 00-1.21 0 1.337 1.337 0 00-.042-.274 1.789 1.789 0 00-.274-.513l1.843-.012z",
  fill: "currentColor"
});

var _ref2$x =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.012 12.012 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

function SvgAviator(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$$({
      className: "aviator_svg__icon aviator_svg__icon--frame-shape-aviator",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$$, _ref2$x)
  );
}

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$_ =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 23.876c-2.373-.001-4.693-.702-6.666-2.014a11.951 11.951 0 01-4.418-5.36 11.88 11.88 0 01-.68-6.897 11.919 11.919 0 013.285-6.111A12.02 12.02 0 019.663.229c2.328-.46 4.74-.223 6.933.681A11.987 11.987 0 0121.98 5.31 11.894 11.894 0 0124 11.942a11.919 11.919 0 01-3.52 8.437 12.044 12.044 0 01-8.484 3.497zm0-23.093c-2.218 0-4.387.656-6.23 1.882a11.172 11.172 0 00-4.13 5.01 11.105 11.105 0 00-.637 6.446 11.142 11.142 0 003.07 5.713 11.236 11.236 0 005.744 3.053c2.176.43 4.431.209 6.48-.636a11.204 11.204 0 005.034-4.11 11.118 11.118 0 001.89-6.2 11.138 11.138 0 00-3.289-7.889 11.255 11.255 0 00-7.932-3.27z",
  fill: "currentColor"
});

var _ref2$w =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.111 9.637c-1.804.105-4.375.623-6.344 1.997a.859.859 0 00-.298.28 2.244 2.244 0 00-.947-.007.94.94 0 00-.293-.273C9.272 10.26 6.685 9.742 4.88 9.637c-.888 0-1.111.171-.747 1.35.364 1.18 1.44 3.996 3.972 4.342a3.242 3.242 0 002.051-.508 3.215 3.215 0 001.296-1.66c.035-.137.062-.254.082-.363.174-.063.36-.087.544-.07.135.005.267.034.391.086.024.105.047.218.083.347a3.21 3.21 0 001.295 1.661c.607.394 1.33.572 2.051.507 2.532-.346 3.609-3.158 3.973-4.341.364-1.184.133-1.332-.76-1.351z",
  fill: "currentColor"
});

function SvgCatEye(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$_({
      className: "cat-eye_svg__icon cat-eye_svg__icon--frame-shape-cat-eye",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$_, _ref2$w)
  );
}

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Z =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.012 12.012 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

var _ref2$v =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.962 9.655c-4.123 0-8.072.165-8.072.165-.205 0-.373.156-.373.347v.635c0 .173.1.334.263.418l.092.05c.106.055.17.16.166.273-.018.53.02 1.862.78 3.047.926 1.439 4.234 1.5 5.226.246s.988-1.77 1.279-2.385a.8.8 0 01.53-.442.646.646 0 01.33 0 .795.795 0 01.529.442c.291.615.287 1.131 1.279 2.385.992 1.255 4.3 1.193 5.226-.246.76-1.185.798-2.517.782-3.047a.298.298 0 01.166-.274l.092-.05a.474.474 0 00.26-.417v-.635c0-.191-.167-.347-.372-.347 0 0-4.06-.165-8.183-.165z",
  fill: "currentColor"
});

function SvgMask(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$Z({
      className: "mask_svg__icon mask_svg__icon--frame-shape-mask",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$Z, _ref2$v)
  );
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$Y =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 13c0 1.38-1.567 2.5-3.5 2.5S4 14.38 4 13c0-.254-.183-.5-.436-.5H3.46a.46.46 0 01-.46-.46V12a.5.5 0 01.5-.5h.714c.312 0 .606-.128.863-.304.629-.431 1.483-.696 2.423-.696 1.088 0 2.06.355 2.702.91a.274.274 0 00.265.053c.442-.147 1-.213 1.533-.213.533 0 1.09.066 1.533.213.091.03.192.01.265-.052.642-.556 1.614-.911 2.702-.911.94 0 1.794.265 2.423.696.257.176.551.304.863.304h.714a.5.5 0 01.5.5v.04a.46.46 0 01-.46.46h-.104c-.253 0-.436.246-.436.5 0 1.38-1.567 2.5-3.5 2.5S13 14.38 13 13c0-.342-.174-.697-.515-.728a5.283 5.283 0 00-.97 0c-.34.031-.515.386-.515.728z",
  fill: "currentColor"
});

var _ref2$u =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.011 12.011 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

function SvgOval(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$Y({
      className: "oval_svg__icon oval_svg__icon--frame-shape-oval",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$Y, _ref2$u)
  );
}

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$X =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.011 12.011 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

var _ref2$t =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.077 10H8.81a2.19 2.19 0 011.608.704.8.8 0 00.735.254 4.27 4.27 0 01.846-.083c.28 0 .569.026.846.083a.8.8 0 00.735-.254A2.19 2.19 0 0115.189 10h4.162A1.649 1.649 0 0121 11.649v1.234a2.857 2.857 0 01-1.887 2.687l-.531.192a4.001 4.001 0 01-1.359.238H16.18a3.047 3.047 0 01-2.766-1.77l-.112-.244A3.275 3.275 0 0113 12.614v-.425a.201.201 0 00-.137-.197 3.072 3.072 0 00-.863-.117c-.314 0-.614.042-.863.117a.201.201 0 00-.137.197v.425c0 .474-.103.942-.302 1.372l-.112.244A3.047 3.047 0 017.82 16H6.777a4 4 0 01-1.359-.238l-.531-.192A2.857 2.857 0 013 12.883v-1.234A1.649 1.649 0 014.649 10h1.428z",
  fill: "currentColor"
});

function SvgRectangle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$X({
      className: "rectangle_svg__icon rectangle_svg__icon--frame-shape-rectangle",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$X, _ref2$t)
  );
}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$W =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 23.876c-2.373-.001-4.693-.702-6.666-2.014a11.951 11.951 0 01-4.418-5.36 11.88 11.88 0 01-.68-6.897 11.919 11.919 0 013.285-6.111A12.02 12.02 0 019.663.229c2.328-.46 4.74-.223 6.933.681A11.987 11.987 0 0121.98 5.31 11.894 11.894 0 0124 11.942a11.919 11.919 0 01-3.52 8.437 12.044 12.044 0 01-8.484 3.497zm0-23.093c-2.218 0-4.387.656-6.23 1.882a11.172 11.172 0 00-4.13 5.01 11.105 11.105 0 00-.637 6.446 11.142 11.142 0 003.07 5.713 11.236 11.236 0 005.744 3.053c2.176.43 4.431.209 6.48-.636a11.204 11.204 0 005.034-4.11 11.118 11.118 0 001.89-6.2 11.138 11.138 0 00-3.289-7.889 11.255 11.255 0 00-7.932-3.27z",
  fill: "currentColor"
});

var _ref2$s =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.152 10.556c-.713 0-1.566-.7-1.566-.7a3.425 3.425 0 00-2.566-.818 3.433 3.433 0 00-2.365 1.284s-.474-.042-.893-.112a7.253 7.253 0 00-1.542 0 11.68 11.68 0 01-.924.073A3.416 3.416 0 007.94 9.04a3.438 3.438 0 00-2.539.82s-.86.7-1.565.7l-.31.164-.043 1.009s.74-.12.748.413v.303a3.398 3.398 0 00.93 2.543 3.433 3.433 0 002.497 1.072 3.448 3.448 0 002.497-1.072 3.413 3.413 0 00.93-2.543c-.001-.18-.016-.36-.044-.537 0-.07-.027-.14-.043-.206-.086-.701.466-.662.466-.662h1.186c.356 0 .391.335.36.588a3.501 3.501 0 00-.094.822 3.4 3.4 0 00.963 2.488 3.432 3.432 0 002.467 1.041 3.448 3.448 0 002.468-1.041 3.413 3.413 0 00.963-2.489v-.187-.117c0-.533.747-.412.747-.412l-.101-.962-.27-.202v-.016z",
  fill: "currentColor"
});

function SvgRound(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$W({
      className: "round_svg__icon round_svg__icon--frame-shape-round",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$W, _ref2$s)
  );
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$V =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.738 10.325h-.391a3.162 3.162 0 00-1.112-1.174l-.062-.032a2.905 2.905 0 00-.627-.277l-.176-.055a3.025 3.025 0 00-.783-.114H7.39a3.08 3.08 0 00-.783.114l-.176.055c-.219.069-.429.162-.626.277l-.06.032a3.131 3.131 0 00-1.115 1.174 1.852 1.852 0 01-.356.035c-.25 0-.454-.05-.454.2v2.485c0 .25.204.196.454.196.098 0 .176.039.25 0 .392 1.22 1.148 2.606 2.161 3.017a1.752 1.752 0 00.705.157c1.875 0 3.522-2.904 4.599-2.904 1.076 0 2.74 2.904 4.598 2.904.21-.005.419-.046.615-.121a.616.616 0 00.09-.036c1.014-.391 1.78-1.784 2.164-3.005.075.05.149.027.247.027.25 0 .454.027.454-.223v-2.513c.004-.25-.168-.22-.419-.22z",
  fill: "currentColor"
});

var _ref2$r =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.012 12.012 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

function SvgSporty(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$V({
      className: "sporty_svg__icon sporty_svg__icon--frame-shape-sporty",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$V, _ref2$r)
  );
}

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$U =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.023 10.216c-.728.39-1.104.712-1.464.915-.043 0-.047.036-.11.07-.068.05-.143.09-.222.122h-.486l-.066-.023a1.311 1.311 0 01-.235-.118.58.58 0 00-.149-.066c-.443-.35-.905-.676-1.381-.979-1.738-.94-5.088-.254-6.263.125v3.672s.783 1.381 3.582 1.448c2.798.066 3.757-1.824 3.941-2.482a.915.915 0 01.697-.728.931.931 0 01.782.728c.188.658.881 2.544 3.687 2.482 2.807-.063 4.032-1.448 4.032-1.448v-3.671c-1.186-.38-4.587-.999-6.345-.047z",
  fill: "currentColor"
});

var _ref2$q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.996 24A12 12 0 1124 12.004 12.012 12.012 0 0111.996 24zm0-23.213a11.217 11.217 0 1011.221 11.217A11.225 11.225 0 0011.997.787z",
  fill: "currentColor"
});

function SvgSquare(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$U({
      className: "square_svg__icon square_svg__icon--frame-shape-square",
      "aria-hidden": "true",
      width: 24,
      height: 24
    }, props), _ref$U, _ref2$q)
  );
}

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$T =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 13.425a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm5.25-3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM4.485 5.926a.75.75 0 01-.586.884c-.978.199-1.9.613-2.698 1.213a.75.75 0 01-.902-1.199A8.217 8.217 0 013.601 5.34a.75.75 0 01.884.586zM19.515 5.926a.75.75 0 01.884-.586 8.217 8.217 0 013.302 1.484.75.75 0 11-.902 1.2 6.717 6.717 0 00-2.698-1.214.75.75 0 01-.586-.884zM13.5 13.425a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm5.25-3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z",
  fill: "currentColor"
});

var _ref2$p =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 13.425a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgGlasses(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$T({
      className: "glasses_svg__icon glasses_svg__icon--glasses-frames",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$T, _ref2$p)
  );
}

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$S =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.61 8.45c.276.02.332.083.35.344.004.073.015.135.017.206.018.289.018.578.018.87a.233.233 0 01-.03.168.244.244 0 01-.135.107.803.803 0 00-.408.251.777.777 0 00-.187.434c-.069.42-.151.836-.226 1.253a8.612 8.612 0 01-.533 1.909 2.453 2.453 0 01-1.066 1.302 5.782 5.782 0 01-1.87.636l.014.07-.023-.07a5.83 5.83 0 01-1.203.062c-1.885-.104-3.594-.969-4.476-2.64a15.55 15.55 0 01-.882-2.102.993.993 0 00-.368-.497 1.031 1.031 0 00-1.196 0 .995.995 0 00-.369.497c-.241.72-.536 1.422-.882 2.101-.884 1.672-2.59 2.537-4.475 2.64a5.815 5.815 0 01-3.082-.697 2.454 2.454 0 01-1.067-1.302 8.724 8.724 0 01-.533-1.91c-.037-.212-.077-.423-.117-.634a32.248 32.248 0 01-.11-.618.77.77 0 00-.186-.434.796.796 0 00-.407-.25.243.243 0 01-.174-.276c0-.29 0-.581.04-.873a.97.97 0 01.009-.093c.004-.038.008-.075.008-.113.018-.265.084-.323.351-.344.349-.026.71-.039 1.067-.075.232-.024.462-.052.693-.08.281-.034.562-.069.845-.095l.631-.054 1.66-.133a6.875 6.875 0 011.35.06l.324.034a15.028 15.028 0 011.797.278c.5.107.997.22 1.496.334A7.815 7.815 0 0012 8.893a7.856 7.856 0 001.746-.175c.495-.117.994-.229 1.495-.333.4-.083.816-.156 1.227-.214.188-.026.38-.045.57-.064l.237-.025L17.22 8l.08.08.063-.008a6.873 6.873 0 011.349-.06l1.661.133.172.015.101-.094-.084.096.443.038c.514.047 1.023.122 1.538.175.349.033.709.046 1.066.075zm-3.543.154a6.166 6.166 0 00-.326-.042 11.758 11.758 0 00-2.036-.086l.379.373.032.036-.011.065-.173.984.052.557.15-.139.225.249.48-.235.686-.715.08-.586.003-.033.015-.015.444-.413zm-2.518-.12c-.127.008-.254.017-.38.029a7.392 7.392 0 00-2.4.583c-.155.07-.3.157-.434.26-.06.043-.118.091-.17.144a1.77 1.77 0 00-.15.226l-.06.088c-.03.042-.06.084-.087.128-.076.165-.125.341-.146.521-.012.582.07 1.162.243 1.719.133.517.343 1.012.623 1.469a4.31 4.31 0 001.44 1.344 4.43 4.43 0 001.903.578 7.097 7.097 0 001.48-.006l-1.027-3.1-.575.162-.059-.212-.724 1.87.28-1.484-.79.038.83-.249.11-.575-.366-.022-2.09.993 2.009-1.405.114-.723-.74-.505-1.198-.263 1.271-.014h.019l.039.018 1.028.503.041-.67.002-.035.003-.009.27-.945-.31-.456zm1.92 7.076c.282-.034.557-.107.818-.217.09-.04.194-.082.284-.117l.084-.034c.105-.041.203-.107.304-.156.281-.14.527-.338.72-.582.194-.243.329-.526.397-.827a8.506 8.506 0 00.26-3.305 3.446 3.446 0 00-.172-.653 1.24 1.24 0 00-.128-.235 1.242 1.242 0 00-.655-.47 6.174 6.174 0 00-1.218-.344l-.411.47.052.67-.036.05-.55.776.31.22.21.129.515.048.635-.71-.39.732.139.013.04.004.02.012.721.453.582-.461-.531.595-.029.031-.05-.02-.784-.328-.433.01-.719.23.187.68 1.785 2.202-1.964-1.754-.031-.036-.56-.117.137.66.454-.507-.402.756.41 2.132zM9.41 13.648c.281-.457.492-.952.626-1.469v.005a5.416 5.416 0 00.253-1.716 1.734 1.734 0 00-.146-.52c-.045-.076-.099-.144-.147-.217a1.768 1.768 0 00-.15-.226c-.052-.052-.109-.1-.17-.143a2.13 2.13 0 00-.434-.26 7.394 7.394 0 00-2.4-.584 11.765 11.765 0 00-2.571.05c-.566.056-1.12.19-1.646.398a1.24 1.24 0 00-.783.705c-.08.212-.138.431-.173.654a8.515 8.515 0 00.253 3.3c.067.3.203.583.396.827.194.243.44.442.721.582.04.019.076.04.113.06.058.032.118.064.19.096.12.052.249.096.368.15.299.126.615.204.938.23.472.047.948.047 1.418 0a4.43 4.43 0 001.904-.578 4.32 4.32 0 001.44-1.344zm8.66-1.485l.431-.187.637.286-.155-.744.335-.302-.403-.53-.206.317-.455-.23-.295.182-.316-.234-.34.508.184.217.022.195.426.027.135.495z",
  fill: "currentColor"
});

function SvgGlassesBroken(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$S({
      className: "glasses-broken_svg__icon glasses-broken_svg__icon--glasses-broken",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$S)
  );
}

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$R =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 13.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM0 17.25a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zM18.75 13.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm-5.25 3.75a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0z",
  fill: "currentColor"
});

var _ref2$o =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 17.25a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM3.75 3A2.25 2.25 0 001.5 5.25v12a.75.75 0 01-1.5 0v-12A3.75 3.75 0 013.75 1.5h.75a.75.75 0 010 1.5h-.75zM18.75 2.25a.75.75 0 01.75-.75h.75A3.75 3.75 0 0124 5.25v12a.75.75 0 01-1.5 0v-12A2.25 2.25 0 0020.25 3h-.75a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgGlassesRetro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$R({
      className: "glasses-retro_svg__icon glasses-retro_svg__icon--glasses-retro",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$R, _ref2$o)
  );
}

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$Q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 16.5a.375.375 0 100 .75.375.375 0 000-.75z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$n =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 13.5V5.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3$b =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgAlertCircle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$Q({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$Q, _ref2$n, _ref3$b)
  );
}

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$P =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2.249a2.25 2.25 0 012.25-2.25h19.5A2.25 2.25 0 0124 2.249v19.5a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 21.749v-19.5zm2.25-.75a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75v-19.5a.75.75 0 00-.75-.75H2.25z",
  fill: "currentColor"
});

var _ref2$m =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.45 3.899a.75.75 0 01.15 1.05l-4.5 6a.75.75 0 01-1.13.08l-3-3a.75.75 0 011.06-1.06L7.42 9.357 11.4 4.05a.75.75 0 011.05-.15zM13.5 8.249a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM12.45 12.899a.75.75 0 01.15 1.05l-4.5 6a.75.75 0 01-1.13.08l-3-3a.75.75 0 011.06-1.06l2.389 2.388L11.4 13.05a.75.75 0 011.05-.15zM13.5 17.249a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgChecklist(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$P({
      className: "checklist_svg__icon checklist_svg__icon--checklist",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$P, _ref2$m)
  );
}

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$O =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.465 6.24a.75.75 0 01.123 1.054l-7.839 9.918a1.799 1.799 0 01-2.916-.085l-2.446-3.471a.75.75 0 111.226-.864l2.45 3.477.01.015a.299.299 0 00.487.014l.009-.011 7.843-9.923a.75.75 0 011.053-.123z",
  fill: "currentColor"
});

function SvgCheckmark(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$O({
      className: "checkmark_svg__icon checkmark_svg__icon--checkmark",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$O)
  );
}

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$N =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12-.001c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-10.5 12c0-5.799 4.701-10.5 10.5-10.5s10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5-10.5-4.701-10.5-10.5zm17.089-4.706a.75.75 0 00-1.177-.93l-7.844 9.923-.008.011a.299.299 0 01-.487-.014l-.01-.015-2.45-3.477a.75.75 0 00-1.226.864l2.445 3.47a1.8 1.8 0 002.917.086l7.84-9.918z",
  fill: "currentColor"
});

function SvgCheckmarkCircle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$N({
      className: "checkmark-circle_svg__icon checkmark-circle_svg__icon--checkmark-circle",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$N)
  );
}

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$M =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.72 8.22a.75.75 0 011.06 0l6.97 6.97 6.97-6.97a.75.75 0 111.06 1.06l-7.146 7.147a1.25 1.25 0 01-1.768 0L3.72 9.28a.75.75 0 010-1.06z",
  fill: "currentColor"
});

function SvgChevronDown(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$M({
      className: "chevron-down_svg__icon chevron-down_svg__icon--chevron-down",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$M)
  );
}

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$L =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.78 3.72a.75.75 0 010 1.06l-6.97 6.97 6.97 6.97a.75.75 0 11-1.06 1.06l-7.146-7.146a1.25 1.25 0 010-1.768L14.72 3.72a.75.75 0 011.06 0z",
  fill: "currentColor"
});

function SvgChevronLeft(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$L({
      className: "chevron-left_svg__icon chevron-left_svg__icon--chevron-left",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$L)
  );
}

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$K =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.22 20.28a.75.75 0 010-1.06l6.97-6.97-6.97-6.97a.75.75 0 011.06-1.06l7.146 7.146a1.25 1.25 0 010 1.768L9.28 20.28a.75.75 0 01-1.06 0z",
  fill: "currentColor"
});

function SvgChevronRight(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$K({
      className: "chevron-right_svg__icon chevron-right_svg__icon--chevron-right",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$K)
  );
}

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$J =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.28 15.78a.75.75 0 01-1.06 0l-6.97-6.97-6.97 6.97a.75.75 0 11-1.06-1.06l7.146-7.147a1.25 1.25 0 011.768 0l7.146 7.147a.75.75 0 010 1.06z",
  fill: "currentColor"
});

function SvgChevronUp(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$J({
      className: "chevron-up_svg__icon chevron-up_svg__icon--chevron-up",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$J)
  );
}

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$I =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.941 18l-5.197-5.045a.347.347 0 010-.499l5.197-5.044M17.396 18L12.2 12.955a.347.347 0 010-.499l5.197-5.044",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDoubleChevronLeft(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$I({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$I)
  );
}

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$H =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.242 7.412l5.197 5.044a.348.348 0 010 .5L12.242 18M6.787 7.412l5.197 5.044a.348.348 0 010 .5L6.787 18",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDoubleChevronRight(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$H({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$H)
  );
}

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.53 9.182a.75.75 0 00-1.06-1.06L12 11.592l-3.47-3.47a.75.75 0 00-1.06 1.06l3.47 3.47-3.47 3.471a.75.75 0 101.06 1.06l3.47-3.47 3.47 3.47a.75.75 0 001.06-1.06l-3.47-3.47 3.47-3.47z",
  fill: "currentColor"
});

function SvgClear(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$G({
      className: "clear_svg__icon clear_svg__icon--clear",
      width: 24,
      height: 24,
      viewBox: "0 0 24 25",
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$G)
  );
}

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M.2 12c0 6.5 5.3 11.8 11.8 11.8V22C6.5 22 2 17.5 2 12H.2zM12 .2C5.5.2.2 5.5.2 12H2C2 6.5 6.5 2 12 2V.2zM23.8 12C23.8 5.5 18.5.2 12 .2V2c5.5 0 10 4.5 10 10h1.8zM12 23.8c6.5 0 11.8-5.3 11.8-11.8H22c0 5.5-4.5 10-10 10v1.8zM11.7 12V8.1H9.9V12h1.8zm0-3.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9h1.8zM9.9 12c0 .5.4.9.9.9s.9-.4.9-.9H9.9z"
});

var _ref2$l =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.1 12.6l4.8 4.8 1.3-1.3-4.8-4.8-1.3 1.3zm4.9 4.9c.4.4.9.4 1.3 0s.4-.9 0-1.3L15 17.5zm-3.6-6.1c-.4-.4-.9-.4-1.3 0s-.4.9 0 1.3l1.3-1.3z"
});

function SvgClock(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$F({
      className: "clock_svg__icon clock_svg__icon--clock",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true"
    }, props), _ref$F, _ref2$l)
  );
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.22 4.22a.75.75 0 011.06 0l6.97 6.97 6.97-6.97a.75.75 0 111.06 1.06l-6.97 6.97 6.97 6.97a.75.75 0 11-1.06 1.06l-6.97-6.97-6.97 6.97a.75.75 0 01-1.06-1.06l6.97-6.97-6.97-6.97a.75.75 0 010-1.06z",
  fill: "currentColor"
});

function SvgClose(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$E({
      className: "close_svg__icon close_svg__icon--close",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$E)
  );
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  clipRule: "evenodd",
  fill: "currentColor",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M0 2.25A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v19.5A2.25 2.25 0 0121.75 24H2.25A2.25 2.25 0 010 21.75zm2.25-.75a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M12.75 13.5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zM12.75 16.5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zM12.75 19.5a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H13.5a.75.75 0 01-.75-.75zM3 13.5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6A.75.75 0 013 13.5zM3 16.5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6A.75.75 0 013 16.5zM3 19.5a.75.75 0 01.75-.75H7.5a.75.75 0 010 1.5H3.75A.75.75 0 013 19.5zM3 4.5A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5V9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 9zm16.5 0h-15V9h15z"
}));

function SvgContent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$D({
      className: "content_svg__icon content_svg__icon--content",
      width: 24,
      height: 24,
      "aria-hidden": "true"
    }, props), _ref$D)
  );
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("ellipse", {
  cx: 1.5,
  cy: 1.412,
  rx: 1.5,
  ry: 1.412,
  fill: "currentColor"
});

var _ref2$k =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("ellipse", {
  cx: 1.5,
  cy: 8,
  rx: 1.5,
  ry: 1.412,
  fill: "currentColor"
});

var _ref3$a =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("ellipse", {
  cx: 1.5,
  cy: 14.588,
  rx: 1.5,
  ry: 1.412,
  fill: "currentColor"
});

function SvgDots(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$C({
      className: "dots_svg__icon dots_svg__icon--dots",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$C, _ref2$k, _ref3$a)
  );
}

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 5.251C7.97 5.183 3.8 8 1.18 10.885a1.663 1.663 0 000 2.226C3.742 15.935 7.9 18.817 12 18.748c4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226C20.2 8 16.031 5.183 12 5.251z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$j =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.75 12a3.75 3.75 0 11-7.5-.002 3.75 3.75 0 017.5.002v0z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEye(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$B({
      className: "eye_svg__icon eye_svg__icon--close",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$B, _ref2$j)
  );
}

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2.783 20.25l18.75-18M8.964 18.301A9.985 9.985 0 0012 18.75c4.1.069 8.258-2.813 10.824-5.637.57-.633.57-1.593 0-2.226A20.572 20.572 0 0019.75 8.13M14.413 5.532A9.549 9.549 0 0012 5.25c-4.03-.067-8.2 2.752-10.82 5.635a1.663 1.663 0 000 2.226 20.8 20.8 0 002.6 2.4M8.25 12A3.75 3.75 0 0112 8.25M15.75 11.999A3.75 3.75 0 0112 15.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEyeSlash(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$A({
      className: "eye-slash_svg__icon eye-slash_svg__icon--close",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$A)
  );
}

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1 11c-1.421 0-2.563-.909-2.9-2.2H5.8c-.4 0-.7-.3-.7-.8s.3-.8.8-.8h8.3C14.538 5.909 15.68 5 17.1 5c1.7 0 3 1.3 3 3s-1.3 3-3 3zm0-4.4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c0-.9-.7-1.5-1.5-1.5zM10.6 18.8c-1.529 0-2.734-1.052-2.961-2.5H4.8c-.4 0-.8-.3-.8-.8s.4-.7.8-.7h2.96c.398-1.184 1.493-2 2.84-2 1.309 0 2.38.77 2.804 1.9H19.4c.4 0 .8.3.8.8s-.4.8-.8.8h-5.838c-.228 1.448-1.433 2.5-2.962 2.5zm0-4.4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c0-.9-.7-1.5-1.5-1.5z",
  fill: "currentColor"
});

function SvgFilter(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$z({
      className: "filter_svg__icon filter_svg__icon--filter",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$z)
  );
}

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.82 4.18l-7.875 15.094v-6.468a.75.75 0 00-.75-.75h-6.47zm.203-1.797a1.183 1.183 0 011.594 1.595v.001l-8.94 17.136a1.184 1.184 0 01-2.232-.546v-7.013H3.43a1.183 1.183 0 01-.546-2.232l17.136-8.94z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgGps(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$y({
      className: "gps_svg__icon gps_svg__icon--gps",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$y)
  );
}

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 5.75A.75.75 0 012.75 5h19.5a.75.75 0 010 1.5H2.75A.75.75 0 012 5.75zm0 6a.75.75 0 01.75-.75h19.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h19.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgHamburger(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$x({
      className: "hamburger_svg__icon hamburger_svg__icon--hamburger",
      width: 24,
      height: 24,
      viewBox: "0.5 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$x)
  );
}

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.25 16.5h-.75A1.5 1.5 0 0112 15v-3.75a.75.75 0 00-.75-.75h-.75M11.625 6.75a.375.375 0 100 .75.375.375 0 000-.75v0",
  stroke: "currentcolor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$i =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z",
  stroke: "currentcolor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInfo(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$w({
      className: "info_svg__icon info_svg__icon--info",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$w, _ref2$i)
  );
}

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.25 16.5h-.75A1.5 1.5 0 0112 15v-3.75a.75.75 0 00-.75-.75h-.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "currentColor"
});

var _ref2$h =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.625 6.75a.375.375 0 100 .75.375.375 0 000-.75v0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInformationCircle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$v({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$v, _ref2$h, _ref3$9)
  );
}

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM2 12a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM2 19.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM8.25 5.125c0-.345.28-.625.625-.625h12.5a.625.625 0 110 1.25h-12.5a.625.625 0 01-.625-.625zM8.25 12.625c0-.345.28-.625.625-.625h12.5a.625.625 0 110 1.25h-12.5a.625.625 0 01-.625-.625zM8.25 20.125c0-.345.28-.625.625-.625h12.5a.625.625 0 110 1.25h-12.5a.625.625 0 01-.625-.625z",
  fill: "currentColor"
});

function SvgList(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$u({
      className: "list_svg__icon list_svg__icon--list",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$u)
  );
}

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.002 17.497a.75.75 0 01.75.75v6a.75.75 0 11-1.5 0v-6a.75.75 0 01.75-.75zM12.002.997a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75zM.002 12.997a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zM16.502 12.997a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

var _ref2$g =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.002 12.998a9 9 0 1118 0 9 9 0 01-18 0zm9-7.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z",
  fill: "currentColor"
});

function SvgLocationCurrent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$t({
      className: "location-current_svg__icon location-current_svg__icon--location-current",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$t, _ref2$g)
  );
}

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.3 1c4 0 7.3 3.3 7.3 7.3 0 3.5-5.4 12.1-6.9 14.5-.1.1-.2.2-.4.2s-.3-.1-.4-.2C10.4 20.4 5 11.8 5 8.3 5 4.3 8.3 1 12.3 1z"
});

var _ref2$f =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.3 11.2c1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9S9.4 6.7 9.4 8.3c0 1.6 1.3 2.9 2.9 2.9z"
});

function SvgLocationPin(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$s({
      className: "location-pin_svg__icon location-pin_svg__icon--location-pin",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$s, _ref2$f)
  );
}

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M18.744 12.071a.79.79 0 01-.79.79H6.045a.79.79 0 110-1.58h11.91a.79.79 0 01.79.79z"
});

function SvgMinus(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$r({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$r)
  );
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.25 5.25a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v13.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5V5.25zM14.25 5.25a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5v13.5a1.5 1.5 0 01-1.5 1.5h-1.5a1.5 1.5 0 01-1.5-1.5V5.25z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentColor"
});

function SvgPause(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$q({
      className: "pause_svg__icon pause_svg__icon--pause",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$q)
  );
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.593 0a4.389 4.389 0 013.126 1.279l.002.002a4.387 4.387 0 01-.039 6.232L8.185 22.01a.75.75 0 01-.344.196l-6.905 1.77a.75.75 0 01-.912-.912l1.77-6.905a.75.75 0 01.196-.344L16.487 1.318A4.389 4.389 0 0119.593 0zm2.067 2.34a2.89 2.89 0 00-4.104.03l-.006.006L3.196 16.73 1.79 22.21l5.479-1.405L21.63 6.443a2.887 2.887 0 00.03-4.102z",
  fill: "currentColor"
});

var _ref2$e =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.136 1.73a.75.75 0 10-1.06 1.06l5.134 5.135a.75.75 0 001.06-1.061L17.136 1.73zM3.05 15.814a.75.75 0 00-1.059 1.061l5.14 5.13a.75.75 0 101.059-1.061l-5.14-5.13z",
  fill: "currentColor"
});

function SvgPencil(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$p({
      className: "pencil_svg__icon pencil_svg__icon--pencil",
      width: 24,
      height: 24,
      "aria-hidden": "true",
      fill: "none"
    }, props), _ref$p, _ref2$e)
  );
}

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9 0C5.328 0 0 5.328 0 11.9s5.328 11.9 11.9 11.9 11.9-5.328 11.9-11.9S18.472 0 11.9 0zM1.3 11.9c0-5.854 4.746-10.6 10.6-10.6 5.854 0 10.6 4.746 10.6 10.6 0 5.854-4.746 10.6-10.6 10.6-5.854 0-10.6-4.746-10.6-10.6zm16.278-.487L12.04 6.566a2.285 2.285 0 00-3.79 1.72v7.23a2.286 2.286 0 003.79 1.72l5.538-4.845a.65.65 0 000-.978zm-7.45-4.025a.985.985 0 011.056.156l4.979 4.358-4.979 4.354a.986.986 0 01-1.634-.741v-7.23c0-.386.226-.737.578-.897z",
  fill: "currentColor"
});

function SvgPlay(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$o({
      className: "play_svg__icon play_svg__icon--play",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$o)
  );
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.75 6.06a.75.75 0 00-1.5 0v4.908H6.343a.75.75 0 000 1.5h4.908v4.907a.75.75 0 101.5 0v-4.907h4.906a.75.75 0 00.001-1.5H12.75V6.061z",
  fill: "currentColor"
});

function SvgPlus(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$n({
      className: "plus_svg__icon plus_svg__icon--add",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$n)
  );
}

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10.681 14.99c0-.816.101-1.465.302-1.948.202-.484.569-.958 1.101-1.424.539-.472.897-.854 1.075-1.145.177-.297.266-.609.266-.935 0-.984-.462-1.476-1.385-1.476-.438 0-.79.134-1.057.402-.26.262-.396.626-.408 1.092H8c.012-1.113.376-1.983 1.092-2.612C9.814 6.314 10.797 6 12.04 6c1.255 0 2.229.3 2.921.9C15.654 7.494 16 8.336 16 9.425c0 .495-.113.964-.337 1.406-.225.437-.619.924-1.181 1.46l-.72.672c-.45.425-.707.923-.772 1.494l-.036.533h-2.273zm-.257 2.682c0-.39.133-.71.4-.961.272-.256.618-.384 1.038-.384.42 0 .764.128 1.03.384.273.25.409.57.409.961 0 .384-.133.702-.4.952-.26.25-.607.376-1.039.376-.432 0-.781-.125-1.047-.376-.26-.25-.391-.567-.391-.952z",
  fill: "currentColor"
});

function SvgQuestionmark(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$m({
      className: "questionmark_svg__icon questionmark_svg__icon--question-mark",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$m)
  );
}

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.364 1.704a8.806 8.806 0 0110.18 13.78l5.74 5.74a.75.75 0 01-1.062 1.06l-5.739-5.74a8.806 8.806 0 11-9.12-14.841zm8.637 13.246a.798.798 0 00-.052.052 7.306 7.306 0 11.053-.053z",
  fill: "currentColor"
});

function SvgSearch(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$l({
      className: "search_svg__icon search_svg__icon--search",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$l)
  );
}

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.25 2.56v8.69a.75.75 0 001.5 0V2.56l2.47 2.47a.75.75 0 101.06-1.06L12.53.22a.748.748 0 00-1.06 0L7.72 3.97a.75.75 0 001.06 1.06l2.47-2.47z",
  fill: "currentColor"
});

var _ref2$d =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.25 9a.75.75 0 00-.75.75v12c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-12a.75.75 0 00-.75-.75h-1.5a.75.75 0 010-1.5h1.5A2.25 2.25 0 0121 9.75v12A2.25 2.25 0 0118.75 24H5.25A2.25 2.25 0 013 21.75v-12A2.25 2.25 0 015.25 7.5h1.5a.75.75 0 110 1.5h-1.5z",
  fill: "currentColor"
});

function SvgShare(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$k({
      className: "share_svg__icon share_svg__icon--share",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$k, _ref2$d)
  );
}

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 6.75A.75.75 0 015.75 6h12a.75.75 0 010 1.5h-12A.75.75 0 015 6.75zM5 11.25a.75.75 0 01.75-.75H11a.75.75 0 010 1.5H5.75a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

var _ref2$c =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M13.629 23.25H2.25a1.5 1.5 0 01-1.5-1.5V2.25a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v11.379a1.5 1.5 0 01-.439 1.06l-8.122 8.122a1.5 1.5 0 01-1.06.439z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.25 14.5a.75.75 0 00-.75.75v7.365a.75.75 0 01-1.5 0V15.25A2.25 2.25 0 0115.25 13h7.365a.75.75 0 010 1.5H15.25z",
  fill: "currentColor"
});

function SvgSheet(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$j({
      className: "sheet_svg__icon sheet_svg__icon--sheet",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$j, _ref2$c, _ref3$8)
  );
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.243 12.47a.75.75 0 011.06 0l3.182 3.182a.75.75 0 010 1.06l-6.364 6.36A3 3 0 01.88 18.83l6.364-6.36zm.53 1.59l-5.834 5.83a1.5 1.5 0 002.122 2.122l5.833-5.83-2.121-2.121z",
  fill: "currentColor"
});

var _ref2$b =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.91 5.042a.75.75 0 010 1.06l-9.016 9.015a.75.75 0 01-1.06-1.06l9.015-9.015a.75.75 0 011.06 0z",
  fill: "currentColor"
});

var _ref3$7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5.27a.75.75 0 011.061 0l2.121 2.12a.75.75 0 010 1.06L21.03 6.102A2.25 2.25 0 1117.85 2.92L20.5.27zm.53 1.59l-2.12 2.12a.75.75 0 001.06 1.062L22.09 2.92l-1.06-1.06zM4.486.552a.75.75 0 01.712-.35 4.458 4.458 0 012.693 1.272l.003.002A4.498 4.498 0 019.056 5.82l1.965 1.97A.75.75 0 119.959 8.85L7.67 6.555a.75.75 0 01-.167-.804 2.998 2.998 0 00-.669-3.214 2.958 2.958 0 00-.527-.416 3.743 3.743 0 01-4.128 4.135l.014.023a2.97 2.97 0 003.604 1.17.75.75 0 01.807.167L8.18 9.192a.75.75 0 11-1.06 1.06l-1.25-1.25a4.47 4.47 0 01-5.615-3.85.75.75 0 011.143-.714 2.243 2.243 0 003.09-3.092.75.75 0 01-.001-.794zM15.092 12.922a.75.75 0 011.06 0l2.186 2.185a4.5 4.5 0 11-3.182 3.182l-1.45-1.449a.75.75 0 011.061-1.06l1.775 1.774a.75.75 0 01.168.804 3 3 0 101.697-1.697.75.75 0 01-.804-.168l-2.511-2.51a.75.75 0 010-1.061z",
  fill: "currentColor"
});

var _ref4$3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.704 18.656a1.125 1.125 0 101.592 1.59 1.125 1.125 0 00-1.592-1.59z",
  fill: "currentColor"
});

function SvgTools(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$i({
      className: "tools_svg__icon tools_svg__icon--tools",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$i, _ref2$b, _ref3$7, _ref4$3)
  );
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.8 5.5l1.3 15.8c0 .4.4.7.7.7h10.7c.4 0 .7-.3.7-.7l1.3-15.8H4.8zm16.441 0L19.9 21.4c-.1 1.2-1.1 2.1-2.3 2.1H6.9c-1.199 0-2.1-.9-2.199-2.1L3.358 5.5H1.8c-.5 0-.8-.3-.8-.7 0-.4.3-.8.8-.8h5.9v-.8C7.8 2 8.8 1 10 1h4.5c1.2 0 2.2 1 2.2 2.2V4h6.1c.4 0 .8.3.8.8s-.4.7-.8.7H21.24zM15.201 4v-.8c0-.4-.3-.8-.8-.8H10c-.4 0-.8.3-.8.8V4h6zm-6 13.4c0 .5.4.8.799.8.4 0 .8-.3.8-.7V10c0-.4-.3-.8-.8-.8s-.8.4-.8.8v7.4zm5.299.8c-.4 0-.8-.3-.8-.8V10c0-.4.3-.8.8-.8s.8.3.8.8v7.5c-.1.4-.4.7-.8.7z",
  fill: "currentColor"
});

function SvgTrash(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$h({
      className: "trash_svg__icon trash_svg__icon--trash",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$h)
  );
}

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0a6 6 0 100 12 6 6 0 000-12zM7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3 23.25a9 9 0 019-9 9 9 0 019 9 .75.75 0 001.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 001.5 0z",
  fill: "currentColor"
});

function SvgUser(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$g({
      className: "user_svg__icon user_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$g)
  );
}

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M6 6.75a3 3 0 100-6 3 3 0 000 6z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$a =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.674 9.75A5.25 5.25 0 00.75 13.5v2.25H3l.75 7.5h4.5l.285-2.85",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.75 21a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.25 23.25l-3.788-3.788",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUserSearch(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$f({
      className: "user-search_svg__icon user-search_svg__icon--user-search",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$f, _ref2$a, _ref3$6, _ref4$2)
  );
}

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 18.75a.375.375 0 100 .75.375.375 0 000-.75v0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 15.75v-7.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3$5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M13.621 1.76a1.806 1.806 0 00-3.242 0L.906 21.058a1.52 1.52 0 001.366 2.192h19.456a1.52 1.52 0 001.366-2.192L13.621 1.76z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWarning(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$e({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$e, _ref2$9, _ref3$5)
  );
}

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M1.79 15.195c-.802-1.925 2.9-5.558 8.478-7.746 5.577-2.232 10.798-2.1 11.6-.175 1.518 3.72-1.65 8.578-7.227 10.81-5.622 2.188-11.333.83-12.85-2.889zm-1.56.613c1.918 4.682 8.655 6.258 15.035 3.763 6.336-2.538 10.084-8.27 8.165-12.91-1.293-3.107-7.45-3.238-13.786-.744-6.38 2.539-10.709 6.784-9.415 9.89z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M13.391 15.02c-5.577 2.232-10.797 2.1-11.6.175-.803-1.925 2.9-5.558 8.477-7.746 5.577-2.232 10.798-2.1 11.6-.175.76 1.882-2.9 5.514-8.477 7.746zm.625 1.532c6.336-2.538 10.664-6.783 9.414-9.89-1.293-3.108-7.45-3.239-13.786-.745-6.38 2.539-10.709 6.784-9.415 9.89 1.294 3.108 7.407 3.24 13.787.745z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M3.35 14.713c.402-.657.982-1.313 1.696-1.926.669-.612 1.472-1.181 2.275-1.663.268-.175.535-.306.803-.437.134-.088.223-.132.312-.175l-.356-.744c-.045.043-.179.087-.313.175a7.79 7.79 0 00-.803.481c-.848.525-1.65 1.094-2.365 1.75-.758.7-1.383 1.401-1.829 2.101l.58.438z"
}));

function SvgLens(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$d({
      className: "lens_svg__icon lens_svg__icon--lens",
      width: 24,
      height: 24,
      "aria-hidden": "true",
      fill: "none"
    }, props), _ref$d)
  );
}

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.347 4.022a1.11 1.11 0 00-1.724 0c-1.382 1.692-3.653 4.74-3.653 6.491a4.52 4.52 0 004.515 4.516A4.52 4.52 0 0024 10.513c0-1.75-2.27-4.799-3.653-6.491zm-.862 1.034a34.382 34.382 0 00-1.49 1.984c-.492.71-.935 1.427-1.252 2.077-.333.684-.452 1.148-.452 1.396a3.2 3.2 0 003.194 3.195 3.2 3.2 0 003.194-3.195c0-.248-.119-.712-.452-1.396-.316-.65-.76-1.367-1.25-2.077a34.296 34.296 0 00-1.492-1.984z",
  fill: "currentColor"
});

var _ref2$8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.887 7.002c.325-.513-.031-1.19-.636-1.13-1.772.179-3.755.67-5.759 1.458-5.618 2.236-9.43 5.974-8.29 8.71 1.69 4.123 7.622 5.51 13.24 3.314a14.927 14.927 0 003.28-1.812c.393-.288.264-.897-.171-1.114a.778.778 0 00-.803.06 13.472 13.472 0 01-2.855 1.556c-3.147 1.224-6.325 1.188-8.566.158 2.231.153 5.092-.364 8.016-1.507.682-.273 1.338-.57 1.962-.883.386-.194.45-.713.18-1.05a.744.744 0 00-.909-.218c-.564.284-1.16.553-1.783.802-4.912 1.966-9.509 1.85-10.216.154-.707-1.695 2.554-4.894 7.465-6.82 1.901-.762 3.755-1.21 5.355-1.377a.655.655 0 00.49-.3z",
  fill: "currentColor"
});

var _ref3$4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4.445 13.38c-.628.54-1.14 1.118-1.493 1.696l-.51-.386c.392-.616.942-1.233 1.61-1.85.63-.578 1.336-1.079 2.083-1.541a6.85 6.85 0 01.707-.424 1.49 1.49 0 01.167-.091.478.478 0 00.108-.063l.314.655a2.255 2.255 0 00-.275.154c-.235.116-.471.231-.707.386-.707.423-1.414.925-2.004 1.464z",
  fill: "currentColor"
});

function SvgSolution(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$c({
      width: 24,
      height: 24,
      fill: "none"
    }, props), _ref$c, _ref2$8, _ref3$4)
  );
}

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 13.425a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm5.25-3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM4.485 5.926a.75.75 0 01-.586.884c-.978.199-1.9.614-2.698 1.214a.75.75 0 01-.902-1.2A8.217 8.217 0 013.601 5.34a.75.75 0 01.884.586zM19.515 5.926a.75.75 0 01.884-.586 8.217 8.217 0 013.302 1.485.75.75 0 11-.902 1.199 6.717 6.717 0 00-2.698-1.214.75.75 0 01-.586-.884zM13.5 13.425a5.25 5.25 0 1110.5 0 5.25 5.25 0 01-10.5 0zm5.25-3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z",
  fill: "currentColor"
});

var _ref2$7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 13.425a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z",
  fill: "currentColor"
});

function SvgFrame(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$b({
      className: "frame_svg__icon frame_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$b, _ref2$7)
  );
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.75 11.25a1.5 1.5 0 011.5-1.5h13.5a1.5 1.5 0 011.5 1.5v10.5a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-10.5z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.75 9.75V6a5.25 5.25 0 0110.5 0v3.75M12 15v3",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLock(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$a({
      className: "lock_svg__icon lock_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$a, _ref2$6)
  );
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.25 12.004H7.5M11.25 15.754l-3.75-3.75 3.75-3.75M20.693 16.6a10.5 10.5 0 11-.179-9.542",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLogout(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$9({
      className: "logout_svg__icon logout_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$9)
  );
}

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M22.306 4.873c.57.228.944.78.944 1.393v11.469a1.5 1.5 0 01-.943 1.392l-9.749 3.9a1.5 1.5 0 01-1.116-.001l-9.703-3.898a1.5 1.5 0 01-.94-1.392V6.264a1.5 1.5 0 01.94-1.392L11.44.98a1.5 1.5 0 011.116 0l9.751 3.894z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.187 7.275L7.025 2.806M12.008 9.744L1.136 5.41M12 22.295V9.745M12.095 9.7l10.91-4.338M20.625 16.5l-1.875.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOrders(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$8({
      className: "orders_svg__icon orders_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$8, _ref2$5)
  );
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.25 12l3 3-3 3",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.25 15h-3a7.5 7.5 0 00-7.5 7.5M8.25 19.5h-6A1.5 1.5 0 01.75 18V7.5A1.5 1.5 0 012.25 6h15a1.5 1.5 0 011.5 1.5V9",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.266 6.4l-2.821-4.232A1.5 1.5 0 0014.2 1.5H5.3a1.5 1.5 0 00-1.248.668L1.234 6.4M9.75 1.5V6",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgShipmentNext(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$7({
      className: "shipment-next_svg__icon shipment-next_svg__icon--user",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$7, _ref2$4, _ref3$3)
  );
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M.75 17.25a6.753 6.753 0 019.4-6.208",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2$3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M7.5 9a4.125 4.125 0 100-8.25A4.125 4.125 0 007.5 9zM17.25 23.25a6 6 0 100-12 6 6 0 000 12z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.924 15.505l-2.905 3.874a.751.751 0 01-1.131.08l-1.5-1.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgUserCheckmark(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$6({
      className: "user-checkmark_svg__icon user-checkmark_svg__icon--user-checkmark",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$6, _ref2$3, _ref3$2)
  );
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.75 0A2.25 2.25 0 0121 2.25v19.5A2.25 2.25 0 0118.75 24H5.25A2.25 2.25 0 013 21.75V2.25A2.25 2.25 0 015.25 0h13.5zM4.5 2.25a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v19.5a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V2.25zM12 4.5a.75.75 0 00-.75.75V6h2.25a.75.75 0 010 1.5h-2.25v.75c0 .414.336.75.75.75h1.5a.75.75 0 010 1.5H12a2.25 2.25 0 01-2.25-2.25v-3A2.25 2.25 0 0112 3h1.5a.75.75 0 010 1.5H12zM6 19.75a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.5 0a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm5.25-.75a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zm-9-7a.75.75 0 00-.75.75v4a.75.75 0 001.5 0V15.5h2.75a.75.75 0 000-1.5H7.5v-.5h2.75a.75.75 0 000-1.5h-3.5zm6.923.004a.75.75 0 00-.673.746v4a.75.75 0 001.5 0V16h2.75a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-3.5a.747.747 0 00-.077.004zM16.5 14.5h-2v-1h2v1z",
  fill: "currentColor"
});

function SvgStoreEyeTest(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$5({
      className: "store-eye-test_svg__icon store-eye-test_svg__icon--store-eye-test",
      width: 24,
      height: 24,
      "aria-hidden": "true",
      fill: "none"
    }, props), _ref$5)
  );
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.996 15.052c.312.317.312.698.062.952l-1.434 1.459a8.243 8.243 0 01-4.243 2.283c-1.56.317-3.244 0-4.803-.697-1.498-.762-2.683-1.84-3.494-3.299a8.474 8.474 0 01-1.06-4.758c0-.38.374-.634.748-.634s.624.38.624.761c-.125 1.396.187 2.728.811 3.997.686 1.205 1.684 2.22 2.932 2.727 1.31.571 2.62.762 3.993.508 1.372-.254 2.558-.825 3.556-1.84l1.435-1.459a.596.596 0 01.873 0zM17.623 6.045c.437.444.75.888 1.123 1.395.874 1.396 1.31 2.982 1.248 4.567 0 .381-.312.698-.686.698a.698.698 0 01-.686-.697c.062-1.333-.375-2.665-.998-3.807-.75-1.141-1.747-2.03-2.995-2.537-1.248-.507-2.558-.698-3.868-.38-1.248.253-2.495.888-3.431 1.84l-.873.887a.688.688 0 01-.999 0 .716.716 0 010-1.015l.936-.951c1.123-1.142 2.558-1.967 4.18-2.22 1.56-.318 3.12-.127 4.617.507.873.38 1.746 1.015 2.432 1.713z",
  fill: "currentColor"
});

var _ref2$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.996 15.052a.692.692 0 01.187.444v3.806c0 .38-.312.698-.686.698a.698.698 0 01-.686-.698v-3.171h-3.12a.698.698 0 010-1.396h3.743c.312.19.5.254.562.317zM6.394 3.254a.691.691 0 01.187.444v3.171l3.057-.063a.698.698 0 010 1.395H5.895a.698.698 0 01-.686-.697V3.698c0-.38.312-.698.686-.698.25 0 .374.127.5.254z",
  fill: "currentColor"
});

function Svg360Deg(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$4({
      className: "360-deg_svg__icon 360-deg_svg__icon--360-deg",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$4, _ref2$2)
  );
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M2.25 1.5a.75.75 0 00-.75.75v3a.75.75 0 01-1.5 0v-3A2.25 2.25 0 012.25 0h3a.75.75 0 010 1.5h-3zM18.75 0a.75.75 0 000 1.5h3a.75.75 0 01.75.75v3a.75.75 0 001.5 0v-3A2.25 2.25 0 0021.75 0h-3zM6.937 5.944a4.125 4.125 0 104.057 4.875h2.012a4.125 4.125 0 100-1.5h-2.012a4.125 4.125 0 00-4.056-3.375zm0 1.5a2.625 2.625 0 11.001 5.25 2.625 2.625 0 010-5.25zm10.125 5.25a2.625 2.625 0 110-5.25 2.625 2.625 0 010 5.25zm-2.409 3.891c-1.699.887-3.607.887-5.306 0a.75.75 0 10-.694 1.33c2.133 1.113 4.56 1.113 6.694 0a.75.75 0 00-.694-1.33zM23.25 18a.75.75 0 01.75.75v3A2.25 2.25 0 0121.75 24h-3a.75.75 0 010-1.5h3a.75.75 0 00.75-.75v-3a.75.75 0 01.75-.75zm-21.75.75a.75.75 0 00-1.5 0v3A2.25 2.25 0 002.25 24h3a.75.75 0 000-1.5h-3a.75.75 0 01-.75-.75v-3z"
});

function SvgTryOn(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$3({
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$3)
  );
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.25 9.9L12.273 20.878a6.75 6.75 0 11-9.546-9.546l9.016-9.015a4.5 4.5 0 116.363 6.363L9.091 17.7a2.25 2.25 0 01-3.182-3.181L14.925 5.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPaperclip(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$2({
      className: "paperclip_svg__icon paperclip_svg__icon--paperclip",
      "aria-hidden": "true",
      width: 24,
      height: 24,
      fill: "none"
    }, props), _ref$2)
  );
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.29 24A6.72 6.72 0 1124 17.29 6.72 6.72 0 0117.29 24zm0-12.56a5.85 5.85 0 105.84 5.85 5.85 5.85 0 00-5.84-5.85zM3.33 17.06a.44.44 0 01-.44-.43 5.61 5.61 0 018.31-4.95.44.44 0 01.17.59.43.43 0 01-.59.17 4.75 4.75 0 00-7 4.19.43.43 0 01-.45.43z",
  fill: "currentColor"
});

var _ref2$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.36 20.94a.44.44 0 01-.43-.44V15l-1.81 1.6a.43.43 0 11-.57-.64l2.52-2.24.11-.08H17.47a.38.38 0 01.11.08L20 16a.43.43 0 010 .62.44.44 0 01-.61 0l-1.59-1.55v5.43a.44.44 0 01-.44.44zM8.09 20.78H1.88A1.88 1.88 0 010 18.9v-17A1.88 1.88 0 011.88 0h11.25a1.86 1.86 0 011.38.61l2.71 3a1.84 1.84 0 01.5 1.27v3.37a.44.44 0 01-.87 0V4.83a1 1 0 00-.27-.69l-2.71-2.95a1 1 0 00-.74-.32H1.88a1 1 0 00-1 1v17a1 1 0 001 1h6.21a.43.43 0 110 .86z",
  fill: "currentColor"
});

var _ref3$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.39 10.41a3.76 3.76 0 113.75-3.76 3.76 3.76 0 01-3.75 3.76zm0-6.65a2.89 2.89 0 102.89 2.89 2.9 2.9 0 00-2.89-2.89z",
  fill: "currentColor"
});

var _ref4$1 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.51 5.35a.29.29 0 01.29-.29H10a.29.29 0 01.29.29v1.73a.29.29 0 01-.29.29H6.8a.29.29 0 01-.29-.29z",
  fill: "currentColor"
});

function SvgUploadPd(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends$1({
      className: "upload-pd_svg__icon upload-pd_svg__icon--upload-pd",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref$1, _ref2$1, _ref3$1, _ref4$1)
  );
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.3 23.94a6.7 6.7 0 116.7-6.7 6.71 6.71 0 01-6.7 6.7zm0-12.53a5.84 5.84 0 105.83 5.83 5.84 5.84 0 00-5.83-5.83z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.38 20.89a.44.44 0 01-.43-.44V15l-1.81 1.6a.44.44 0 01-.61 0 .43.43 0 010-.61l2.52-2.24a.41.41 0 01.11-.07H17.33a.4.4 0 01.15 0 .41.41 0 01.11.07L20 16a.43.43 0 010 .61.44.44 0 01-.61 0L17.81 15v5.41a.44.44 0 01-.43.48zM8.1 20.73H1.88A1.88 1.88 0 010 18.86v-17A1.88 1.88 0 011.88 0h11.26a1.86 1.86 0 011.38.61l2.72 2.94a1.84 1.84 0 01.49 1.27v3.41a.43.43 0 01-.86 0V4.82a1 1 0 00-.27-.69l-2.72-2.94a1 1 0 00-.74-.32H1.88a1 1 0 00-1 1v17a1 1 0 001 1H8.1a.43.43 0 010 .86z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5.38 8.05A2.58 2.58 0 118 5.48a2.58 2.58 0 01-2.62 2.57zm0-4.28a1.71 1.71 0 101.71 1.71 1.72 1.72 0 00-1.71-1.71z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.05 5.91H7.52a.43.43 0 01-.43-.43.44.44 0 01.43-.48h1.53a.44.44 0 01.43.44.43.43 0 01-.43.47zM11.49 11.11H3.24a.44.44 0 01-.43-.44.43.43 0 01.43-.43h8.25a.44.44 0 01.44.43.44.44 0 01-.44.44zM10 13.55H3.24a.43.43 0 010-.86H10a.43.43 0 110 .86zM9.05 16H3.24a.44.44 0 01-.43-.44.43.43 0 01.43-.43h5.81a.43.43 0 01.43.43.44.44 0 01-.43.44z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.49 8.05a2.58 2.58 0 112.58-2.57 2.58 2.58 0 01-2.58 2.57zm0-4.28a1.71 1.71 0 101.71 1.71 1.71 1.71 0 00-1.71-1.71z",
  fill: "currentColor"
});

function SvgUploadPrescription(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      className: "upload-prescription_svg__icon upload-prescription_svg__icon--upload-prescription",
      width: 24,
      height: 24,
      fill: "none",
      "aria-hidden": "true"
    }, props), _ref, _ref2, _ref3, _ref4, _ref5)
  );
}

var iconMap = {
    // COMMERCE
    'address-book': React.createElement(SvgAddressBook, null),
    business: React.createElement(SvgBusiness, null),
    'calendar-monthly': React.createElement(SvgCalendarMonthly, null),
    'calendar-quarterly': React.createElement(SvgCalendarQuarterly, null),
    'card-payment': React.createElement(SvgCardPayment, null),
    'cash-payment': React.createElement(SvgCashPayment, null),
    'credit-card': React.createElement(SvgCreditCard, null),
    delivery: React.createElement(SvgDelivery, null),
    'discount-bubble': React.createElement(SvgDiscountBubble, null),
    discount: React.createElement(SvgDiscount, null),
    'eye-test': React.createElement(SvgEyeTest, null),
    'eye-test-alt': React.createElement(SvgEyeTestAlt, null),
    'favourite-empty': React.createElement(SvgFavouriteEmpty, null),
    'favourite-filled': React.createElement(SvgFavouriteFilled, null),
    'iris-scan': React.createElement(SvgIrisScan, null),
    return: React.createElement(SvgReturns, null),
    returns: React.createElement(SvgReturns, null),
    'returns-alt': React.createElement(SvgReturnsAlt, null),
    'shopping-bag': React.createElement(SvgShoppingBag, null),
    store: React.createElement(SvgStore, null),
    truck: React.createElement(SvgTruck, null),
    'left-eye': React.createElement(SvgLeftEye, null),
    'right-eye': React.createElement(SvgRightEye, null),
    printer: React.createElement(SvgPrinter, null),
    // CONTACT
    calendar: React.createElement(SvgCalendar, null),
    location: React.createElement(SvgLocation, null),
    mail: React.createElement(SvgMail, null),
    phone: React.createElement(SvgPhone, null),
    warranty: React.createElement(SvgWarranty, null),
    // FACE SHAPES
    'face-shape-diamond': React.createElement(SvgDiamond, null),
    'face-shape-heart': React.createElement(SvgHeart, null),
    'face-shape-oval': React.createElement(SvgOval$1, null),
    'face-shape-rectangular': React.createElement(SvgRectangular, null),
    'face-shape-round': React.createElement(SvgRound$1, null),
    'face-shape-square': React.createElement(SvgSquare$1, null),
    // FRAME SHAPES
    'frame-shape-almond': React.createElement(SvgAlmond, null),
    'frame-shape-aviator': React.createElement(SvgAviator, null),
    'frame-shape-cat-eye': React.createElement(SvgCatEye, null),
    'frame-shape-mask': React.createElement(SvgMask, null),
    'frame-shape-oval': React.createElement(SvgOval, null),
    'frame-shape-rectangle': React.createElement(SvgRectangle, null),
    'frame-shape-round': React.createElement(SvgRound, null),
    'frame-shape-sporty': React.createElement(SvgSporty, null),
    'frame-shape-square': React.createElement(SvgSquare, null),
    // GLASSES
    'glasses-broken': React.createElement(SvgGlassesBroken, null),
    glasses: React.createElement(SvgGlasses, null),
    'glasses-retro': React.createElement(SvgGlassesRetro, null),
    // INTERFACE
    'alert-circle': React.createElement(SvgAlertCircle, null),
    'chevron-down': React.createElement(SvgChevronDown, null),
    'chevron-left': React.createElement(SvgChevronLeft, null),
    'chevron-right': React.createElement(SvgChevronRight, null),
    'chevron-up': React.createElement(SvgChevronUp, null),
    checklist: React.createElement(SvgChecklist, null),
    checkmark: React.createElement(SvgCheckmark, null),
    'checkmark-circle': React.createElement(SvgCheckmarkCircle, null),
    clock: React.createElement(SvgClock, null),
    close: React.createElement(SvgClose, null),
    content: React.createElement(SvgContent, null),
    clear: React.createElement(SvgClear, null),
    'double-chevron-left': React.createElement(SvgDoubleChevronLeft, null),
    'double-chevron-right': React.createElement(SvgDoubleChevronRight, null),
    dots: React.createElement(SvgDots, null),
    eye: React.createElement(SvgEye, null),
    'eye-slash': React.createElement(SvgEyeSlash, null),
    filter: React.createElement(SvgFilter, null),
    gps: React.createElement(SvgGps, null),
    hamburger: React.createElement(SvgHamburger, null),
    info: React.createElement(SvgInfo, null),
    'information-circle': React.createElement(SvgInformationCircle, null),
    list: React.createElement(SvgList, null),
    'location-current': React.createElement(SvgLocationCurrent, null),
    'location-pin': React.createElement(SvgLocationPin, null),
    minus: React.createElement(SvgMinus, null),
    pause: React.createElement(SvgPause, null),
    paperclip: React.createElement(SvgPaperclip, null),
    pencil: React.createElement(SvgPencil, null),
    plus: React.createElement(SvgPlus, null),
    play: React.createElement(SvgPlay, null),
    questionmark: React.createElement(SvgQuestionmark, null),
    search: React.createElement(SvgSearch, null),
    share: React.createElement(SvgShare, null),
    sheet: React.createElement(SvgSheet, null),
    tools: React.createElement(SvgTools, null),
    trash: React.createElement(SvgTrash, null),
    user: React.createElement(SvgUser, null),
    'user-search': React.createElement(SvgUserSearch, null),
    warning: React.createElement(SvgWarning, null),
    // LENSES
    lens: React.createElement(SvgLens, null),
    solution: React.createElement(SvgSolution, null),
    // MY ACCOUNT
    frame: React.createElement(SvgFrame, null),
    lock: React.createElement(SvgLock, null),
    logout: React.createElement(SvgLogout, null),
    orders: React.createElement(SvgOrders, null),
    'shipment-next': React.createElement(SvgShipmentNext, null),
    'user-checkmark': React.createElement(SvgUserCheckmark, null),
    // PRESCRIPTION
    'store-eye-test': React.createElement(SvgStoreEyeTest, null),
    // PRODUCTS
    '360-deg': React.createElement(Svg360Deg, null),
    'try-on': React.createElement(SvgTryOn, null),
    // UPLOAD
    'upload-prescription': React.createElement(SvgUploadPrescription, null),
    'upload-pd': React.createElement(SvgUploadPd, null),
};
function getIconByName(name) {
    return iconMap[name];
}

var defaultWidth = 24;
var defaultHeight = 24;
var Icon = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.width, width = _c === void 0 ? defaultWidth : _c, _d = _a.height, height = _d === void 0 ? defaultHeight : _d, _e = _a.viewBox, viewBox = _e === void 0 ? "0 0 " + defaultWidth + " " + defaultHeight : _e, className = _a.className, style = _a.style, rest = __rest(_a, ["name", "width", "height", "viewBox", "className", "style"]);
    var icon = getIconByName(name);
    if (!icon || !React.isValidElement(icon)) {
        return React.createElement("span", null,
            "No icon found with name ",
            name);
    }
    var getClassName = function () {
        var base = "icon icon--" + name;
        var addition = className ? " " + className : '';
        return base + addition;
    };
    return React.cloneElement(icon, __assign({ style: style, viewBox: viewBox, width: width + 'px', height: height + 'px', className: getClassName(), 'data-t': rest['data-t'], 'aria-hidden': 'true' }, rest));
};

export { FeatureIcon, Icon };
//# sourceMappingURL=index.es.js.map
